<template>
  <div class="authority" >
    <el-divider content-position="left" style="font-size: 0.28em">员工档案</el-divider>
    <el-row>
      <el-col :span="12" class="m-label" style="color: #409eff;font-size: 16px;">{{ companyRow.company_name }}</el-col>
      <el-col :span="10" class="m-label">
        共：{{ staffCount.total }}人 在职：{{
        staffCount.is_work
        }}
        离职：{{ staffCount.not_work }}
      </el-col>
      <el-col :span="2" class="text-r" style="color: #409eff">
        <!--批量-->
        <el-popconfirm
          cancel-button-text="取消"
          confirm-button-text="确认"
          icon="el-icon-question"
          icon-color="red"
          title="您确认更新吗"
          style="float:right;margin-right: 1.2rem;"
          @onConfirm="handlerelatedStaff"
        >
          <el-button
            slot="reference"
            type="primary"
            icon="el-icon-help"
            circle
            size="mini"
          ></el-button>
        </el-popconfirm>
        <el-button
          type="primary"
          icon="el-icon-circle-plus"
          circle
          size="mini"
          @click="handleAddStaffOpen"
        ></el-button>
      </el-col>
    </el-row>
    <el-row style="margin: 5px 0 5px 0">
      <el-col :span="3">
        <el-select
          v-model="searchArr.id"
          filterable
          remote
          reserve-keyword
          placeholder="请输入员工姓名"
          size="mini"
          clearable
          :remote-method="searchRemoteCompanyMethod"
          :loading="searchLoading"
          @change="handleSearchCompanyChange"
        >
          <el-option
            v-for="item in searchStaffMsgsData"
            :key="item.id"
            :label="item.staff_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="m-con">
      <el-col :span="20">
        <template>
          <div style="line-height: 25px;">
            <el-table
              max-height="650"
              :data="staffMsgsData"
              style="width: 100%; margin-top: 10px"
              border
              :fit='true'
              :header-cell-style="{
              background: '#ecf4ff',
              color: '#333',
              fontWeight: '900',
              fontSize: '0.28rem',
            }"
            >
              <el-table-column
                width="180"
                v-for="(item,index) in tableHeader"
                :key="index"
                show-overflow-tooltip
                :label="item.lable"
                :prop="item.key"
                v-if="colData[index].istrue"
              >
              </el-table-column>
              <el-table-column
                align="center"
                fixed="right">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="查看" placement="top">
                    <el-button type="primary" @click="handleStaffUpdateOpen(scope.row.id, scope.$index)" size="mini" icon="el-icon-user" circle></el-button>
                  </el-tooltip>
                </template>
                <template slot="header" slot-scope="scope">
                  <el-popover placement="bottom" trigger="click">
                    <div class="popper">
                      <div v-for="(item,index) in tableHeader" :key="index">
                        <el-checkbox
                          :label="item.lable"
                          v-model="colOptions"
                          :cheked="colData[index].istrue"
                          @change="heaherChange($event, item.key)"></el-checkbox>
                      </div>
                    </div>
                    <div slot="reference">操作<i class="el-icon-setting"></i></div>
                  </el-popover>
              </template>
              </el-table-column>
            </el-table>
            <div class="block" style="margin-top: 10px; text-align: right;margin-right: 2%">
              <el-pagination
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="sizes, total, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 15, 30, 50, 100]"
                :page-size="pageSize"
                background
              >
              </el-pagination>
            </div>
          </div>
        </template>
      </el-col>
    </el-row>
    <el-drawer
      :title="'添加员工 【' + companyRow.company_name + '】'"
      :visible.sync="addStaffDrawer"
      direction="rtl"
      :before-close="handleAddStaffBeforeClose"
      size="55%"
    >
      <div class="m-tabs-content my_style" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs v-model="showNewTabPane"  :tab-position="tabPosition" type="border-card">
          <el-tab-pane name="first" label=基本信息>
            <el-form
              ref="addStaffsFrom"
              :rules="addStaffRules"
              :model="addStaffsFrom"
              label-width="100px"
              size="mini"
            >
              <div style="margin-left: 70%">
                人员状态：
                <el-radio-group
                  size="mini"
                  v-model="addStaffsFrom.is_inservice"
                >
                  <el-radio-button :value=1 :label=1>在职</el-radio-button>
                  <el-radio-button :value=2 :label=2>离职</el-radio-button>
                </el-radio-group>
              </div>
              <div class="dplx-item-title item-title  small v-ewp-dc49ea38">基础信息</div>
              <el-form-item label="姓名：" prop="staff_name">
                <el-input v-model="addStaffsFrom.staff_name"></el-input>
              </el-form-item>
              <el-form-item label="工号：" prop="work_nnumber">
                <el-input v-model="addStaffsFrom.work_nnumber"></el-input>
              </el-form-item>
              <el-form-item label="证件类型：" prop="number_type">
                <el-select
                  v-model="addStaffsFrom.number_type"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="居民身份证"></el-option>
                  <el-option :value="2" label="外国护照"></el-option>
                  <el-option :value="3" label="港澳居民来往内地通行证"></el-option>
                  <el-option :value="4" label="台湾居民来往大陆通行证"></el-option>
                  <el-option :value="5" label="外国人永久居留身份证(外国人永久居留证)"></el-option>
                  <el-option :value="6" label="中华人民共和国港澳居民居住证"></el-option>
                  <el-option :value="7" label="中华人民共和国台湾居民居住证"></el-option>
                  <el-option :value="8" label="中华人民共和国外国人工作许可证(A类)"></el-option>
                  <el-option :value="9" label="中华人民共和国外国人工作许可证(B类)"></el-option>
                  <el-option :value="10" label="中华人民共和国外国人工作许可证(C类)"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码：" prop="staff_id_number">
                <el-input v-model="addStaffsFrom.staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="其他证件类型：" prop="qt_number_type">
                <el-select
                  v-model="addStaffsFrom.qt_number_type"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="外国护照"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="其他证件证件号码：" prop="qt_staff_id_number">
                <el-input v-model="addStaffsFrom.qt_staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="任职受雇从业类型：" prop="type_employment">
                <el-select
                  v-model="addStaffsFrom.type_employment"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="雇员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                  <el-option :value="3" label="证券经纪人"></el-option>
                  <el-option :value="4" label="实习学生(全日制学历教育)"></el-option>
                  <el-option :value="5" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职年度就业情形：" prop="employment_situation">
                <el-select
                  v-model="addStaffsFrom.employment_situation"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="当年首次入职其他人员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号码：" prop="staff_phone">
                <el-input v-model="addStaffsFrom.staff_phone"></el-input>
              </el-form-item>
              <el-form-item label="国籍：" prop="nationality">
                <el-input v-model="addStaffsFrom.nationality"></el-input>
              </el-form-item>
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  v-model="addStaffsFrom.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="出生日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="性别：" prop="gender">
                <el-select
                  v-model="addStaffsFrom.gender"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="男"></el-option>
                  <el-option :value="2" label="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="入职时间："
                prop="staff_reg_at">
                <el-date-picker
                  v-model="addStaffsFrom.staff_reg_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择入职时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否扣除减除费用：" prop="deduction_expenses">
                <el-select
                  v-model="addStaffsFrom.deduction_expenses"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="2" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="离职时间："
                prop="staff_leave_at"
              >
                <el-date-picker
                  v-model="addStaffsFrom.staff_leave_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择离职时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="籍贯：" prop="native_place">
                <el-input v-model="addStaffsFrom.native_place"></el-input>
              </el-form-item>
              <el-form-item label="婚姻状况：" prop="marital_status">
                <el-select
                  v-model="addStaffsFrom.marital_status"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="未婚"></el-option>
                  <el-option :value="2" label="已婚"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌：" prop="political_status">
                <el-select
                  v-model="addStaffsFrom.political_status"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="群众"></el-option>
                  <el-option :value="2" label="党员"></el-option>
                  <el-option :value="3" label="共青团员"></el-option>
                </el-select>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddStaff"
                size="mini"
                style="float: right;margin-right: 5px"
              >保 存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="in_office" label="任职信息">
            <div class="dplx-item-title item-title">任职信息</div>
            <el-form
              ref="addInOfficeFrom"
              :rules="addInOfficeFromRules"
              :model="addInOfficeFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="员工类型：" prop="type_employee">
                <el-select
                  v-model="addInOfficeFrom.type_employee"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="管理人员"></el-option>
                  <el-option :value="2" label="销售人员"></el-option>
                  <el-option :value="3" label="研发人员"></el-option>
                  <el-option :value="4" label="车间人员"></el-option>
                  <el-option :value="5" label="临时人员"></el-option>
                  <el-option :value="6" label="普通人员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="组别：" prop="employees_group">
                <el-input v-model="addInOfficeFrom.employees_group"></el-input>
              </el-form-item>
              <el-form-item label="岗位：" prop="jobs">
                <el-input v-model="addInOfficeFrom.jobs"></el-input>
              </el-form-item>
              <el-form-item label="工作性质：" prop="nature_work">
                <el-select
                  v-model="addInOfficeFrom.nature_work"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="全职"></el-option>
                  <el-option :value="2" label="兼职"></el-option>
                  <el-option :value="3" label="实习"></el-option>
                  <el-option :value="4" label="劳务"></el-option>
                  <el-option :value="5" label="劳务派遣"></el-option>
                  <el-option :value="6" label="退休返聘"></el-option>
                  <el-option :value="7" label="合同工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工龄：" prop="length_service">
                <el-input v-model="addInOfficeFrom.length_service"></el-input>
              </el-form-item>
              <el-form-item label="试用状态：" prop="trial_status">
                <el-select
                  v-model="addInOfficeFrom.trial_status"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="适用中"></el-option>
                  <el-option :value="2" label="已转正"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="试用期：" prop="probation_period">
                <el-select
                  v-model="addInOfficeFrom.probation_period"
                  size="mini"
                  clearable
                >
                  <el-option :value="0" label="无试用期"></el-option>
                  <el-option :value="1" label="一个月"></el-option>
                  <el-option :value="2" label="二个月"></el-option>
                  <el-option :value="3" label="三个月"></el-option>
                  <el-option :value="4" label="四个月"></el-option>
                  <el-option :value="5" label="五个月"></el-option>
                  <el-option :value="6" label="六个月"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转正日期：" prop="date_conversion">
                <el-date-picker
                  v-model="addInOfficeFrom.date_conversion"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="转正日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="QQ号码：" prop="qq_number">
                <el-input v-model="addInOfficeFrom.qq_number"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人：" prop="emergency_person">
                <el-input v-model="addInOfficeFrom.emergency_person"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系电话：" prop="emergency_phone">
                <el-input v-model="addInOfficeFrom.emergency_phone"></el-input>
              </el-form-item>
              <el-form-item label="薪资停发月份：" prop="salary_suspension">
                <el-date-picker
                  v-model="addInOfficeFrom.salary_suspension"
                  type="month"
                  placeholder="薪资停发月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="club_discontinuation">
                <el-date-picker
                  v-model="addInOfficeFrom.club_discontinuation"
                  type="month"
                  placeholder="社保停缴月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金停缴月份：" prop="provident_discontinuation">
                <el-date-picker
                  v-model="addInOfficeFrom.provident_discontinuation"
                  type="month"
                  placeholder="公积金停缴月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="离职性质：" prop="nature_resignation">
                <el-select
                  v-model="addInOfficeFrom.nature_resignation"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="家庭原因"></el-option>
                  <el-option :value="2" label="身体原因"></el-option>
                  <el-option :value="3" label="薪资原因"></el-option>
                  <el-option :value="4" label="交通不便"></el-option>
                  <el-option :value="5" label="工作压力"></el-option>
                  <el-option :value="6" label="管理问题"></el-option>
                  <el-option :value="7" label="无晋升机会"></el-option>
                  <el-option :value="8" label="职业规划"></el-option>
                  <el-option :value="9" label="合同到期放弃续约"></el-option>
                  <el-option :value="10" label="试用期内辞职"></el-option>
                  <el-option :value="11" label="违反工商条例"></el-option>
                  <el-option :value="12" label="组织调整/裁员"></el-option>
                  <el-option :value="13" label="业绩不达标辞退"></el-option>
                  <el-option :value="14" label="其他原因"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="离职原因：" prop="reasons_leaving">
                <el-input v-model="addInOfficeFrom.reasons_leaving"></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addInOfficeFrom')"
                size="mini"
                style="float: right;margin-right: 5px"
              >保 存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="securityd_accum" label="社保公积金">
            <div class="dplx-item-title item-title">社保公积金</div>
            <el-form
              ref="addSocialSecurityFrom"
              :model="addSocialSecurityFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="参保方案：" prop="insurance_scheme">
                <el-select
                  v-model="addSocialSecurityFrom.insurance_scheme"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="上海社保工商0.16%"></el-option>
                  <el-option :value="2" label="上海社保工商00.256%"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参保城市：" prop="insured_city">
                <el-input v-model="addSocialSecurityFrom.insured_city"></el-input>
              </el-form-item>
              <el-form-item label="户籍性质：" prop="registered_the">
                <el-select
                  v-model="addSocialSecurityFrom.registered_the"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="城镇户籍"></el-option>
                  <el-option :value="2" label="农村户籍"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否缴纳社保：" prop="is_secuity" style="width: 100%!important;">
                <el-radio-group
                  v-model="addSocialSecurityFrom.is_secuity"
                  size="mini"
                >
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="人社证件类型：" prop="staff_id_type">
                <el-select
                  v-model="addSocialSecurityFrom.staff_id_type"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="居民身份证"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人社证件号码：" prop="staff_id_number">
                <el-input v-model="addSocialSecurityFrom.staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="开始参保月份：" prop="month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.month_enrollment"
                  type="month"
                  placeholder="开始参保月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="ting_month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.ting_month_enrollment"
                  type="month"
                  placeholder="社保停缴月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保补缴月份：" prop="bu_month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.bu_month_enrollment"
                  type="month"
                  placeholder="社保补缴月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保账号：" prop="security_number">
                <el-input
                  v-model="addSocialSecurityFrom.security_number"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="社保个人编号：" prop="security_personal_number ">
                <el-input
                  v-model="addSocialSecurityFrom.security_personal_number"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="社保缴纳基数："
                prop="secuity_base"
              >
                <el-input
                  v-model="addSocialSecurityFrom.secuity_base"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否缴纳公积金：" prop="is_accum" style="width: 100%!important;">
                <el-radio-group
                  v-model="addSocialSecurityFrom.is_accum"
                  size="mini"
                >
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开始缴纳月份：" prop="accum_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_starting_month"
                  type="month"
                  placeholder="开始缴纳月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="停止缴存月份：" prop="accum_ting_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_ting_starting_month"
                  type="month"
                  placeholder="停止缴存月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金补缴月份：" prop="accum_bu_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_bu_starting_month"
                  type="month"
                  placeholder="公积金补缴月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金个人账号：" prop="accum_account">
                <el-input
                  v-model="addSocialSecurityFrom.accum_account"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="缴纳基数"
                prop="accum_base"
              >
                <el-input
                  v-model="addSocialSecurityFrom.accum_base"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addSocialSecurityFrom')"
                size="mini"
                style="float: right;margin-right: 5px"
              >保 存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="tax_related" label="涉税信息">
            <div class="dplx-item-title item-title">涉税信息</div>
            <el-form
              ref="addTaxRelatedFrom"
              :model="addTaxRelatedFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="开户银行：" prop="bank_account">
                <el-input v-model="addTaxRelatedFrom.bank_account"></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" prop="bank_number">
                <el-input v-model="addTaxRelatedFrom.bank_number"></el-input>
              </el-form-item>
              <el-form-item label="开户行省份：" prop="bank_account_province">
                <el-input v-model="addTaxRelatedFrom.bank_account_province"></el-input>
              </el-form-item>
              <el-form-item label="银行卡状态：" prop="bank_card_status">
                <el-input v-model="addTaxRelatedFrom.bank_card_status"></el-input>
              </el-form-item>
              <el-form-item label="个人投资额：" prop="personal_investment">
                <el-input v-model.number="addTaxRelatedFrom.personal_investment"></el-input>
              </el-form-item>
              <el-form-item label="个人投资比例(%)：" prop="personal_investment_bl">
                <el-input v-model.number="addTaxRelatedFrom.personal_investment_bl"></el-input>
              </el-form-item>
              <el-form-item label="特殊情况：" prop="special" style="width: 100%!important;">
                <el-radio v-model="addTaxRelatedFrom.special" :label=1>残疾</el-radio>
                <el-radio v-model="addTaxRelatedFrom.special" :label=2>烈属</el-radio>
                <el-radio v-model="addTaxRelatedFrom.special" :label=3>孤老</el-radio>
              </el-form-item>
              <el-form-item
                label="残疾证号"
                prop="disability_number"
              >
                <el-input
                  v-model="addTaxRelatedFrom.disability_number"
                  :disabled="addTaxRelatedFrom.special === 1 ? false : true "
                ></el-input>
              </el-form-item>
              <el-form-item
                label="烈属证号："
                prop="is_martyrs_family_number">
                <el-input
                  v-model="addTaxRelatedFrom.is_martyrs_family_number"
                  :disabled="addTaxRelatedFrom.special === 2 ? false : true "
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" prop="email">
                <el-input v-model="addTaxRelatedFrom.email"></el-input>
              </el-form-item>
              <el-form-item label="学历：" prop="formal_schooling">
                <el-select
                  v-model="addTaxRelatedFrom.formal_schooling"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="研究生"></el-option>
                  <el-option :value="2" label="大学本科"></el-option>
                  <el-option :value="3" label="大学本科以下"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职务：" prop="position">
                <el-select
                  v-model="addTaxRelatedFrom.position"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="高层"></el-option>
                  <el-option :value="2" label="普通"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="纳税人识别号：" prop="taxpayers_number">
                <el-input v-model="addTaxRelatedFrom.taxpayers_number"></el-input>
              </el-form-item>
              <el-form-item label="备注：" prop="note" style="width: 100%!important;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="addTaxRelatedFrom.note">
                </el-input>
              </el-form-item>
              <el-form-item label="经常居住地：" prop="address_permanent">
                <el-input v-model="addTaxRelatedFrom.address_permanent"></el-input>
              </el-form-item>
              <el-form-item label="居住街道：" prop="address_street">
                <el-input v-model="addTaxRelatedFrom.address_street"></el-input>
              </el-form-item>
              <el-form-item label="居住详细地址：" prop="address_full" style="width: 100%!important;">
                <el-input v-model="addTaxRelatedFrom.address_full"></el-input>
              </el-form-item>
              <el-form-item label="户籍所在地：" prop="place_residence">
                <el-input v-model="addTaxRelatedFrom.place_residence"></el-input>
              </el-form-item>
              <el-form-item label="户籍街道：" prop="place_residence_street">
                <el-input v-model="addTaxRelatedFrom.place_residence_street"></el-input>
              </el-form-item>
              <el-form-item label="户籍详细地址：" prop="place_residence_full" style="width: 100%!important;">
                <el-input v-model="addTaxRelatedFrom.place_residence_full"></el-input>
              </el-form-item>
              <el-form-item label="联系地址：" prop="address_contact">
                <el-input v-model="addTaxRelatedFrom.address_contact"></el-input>
              </el-form-item>
              <el-form-item label="联系街道：" prop="address_contact_street">
                <el-input v-model="addTaxRelatedFrom.address_contact_street"></el-input>
              </el-form-item>
              <el-form-item label="联系详细地址：" prop="address_contact_full" style="width: 100%!important;">
                <el-input v-model="addTaxRelatedFrom.address_contact_full"></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addTaxRelatedFrom')"
                size="mini"
                style="float: right;margin-right: 5px"
              >保 存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="contract" label="合同信息">
            <div class="dplx-item-title item-title">合同信息</div>
            <el-form
              ref="addContractFrom"
              :model="addContractFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="合同类型：" prop="contract_type">
                <el-select
                  v-model="addContractFrom.contract_type"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="固定期限劳动合同"></el-option>
                  <el-option :value="2" label="无固定期限劳动合同"></el-option>
                  <el-option :value="3" label="实习协议"></el-option>
                  <el-option :value="4" label="劳务合同"></el-option>
                  <el-option :value="5" label="返聘协议"></el-option>
                  <el-option :value="6" label="劳务派遣合同"></el-option>
                  <el-option :value="7" label="借调合同"></el-option>
                  <el-option :value="0" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同编号：" prop="contract_number">
                <el-input
                  v-model="addContractFrom.contract_number"
                ></el-input>
              </el-form-item>
              <el-form-item label="合同期限：" prop="contract_term">
                <el-select
                  v-model="addContractFrom.contract_term"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="1年"></el-option>
                  <el-option :value="2" label="2年"></el-option>
                  <el-option :value="3" label="3年"></el-option>
                  <el-option :value="4" label="4年"></el-option>
                  <el-option :value="5" label="5年"></el-option>
                  <el-option :value="6" label="6年"></el-option>
                  <el-option :value="7" label="7年"></el-option>
                  <el-option :value="8" label="8年"></el-option>
                  <el-option :value="9" label="9年"></el-option>
                  <el-option :value="10" label="10年"></el-option>
                  <el-option :value="0" label="永久"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签订日期" prop="date_signing">
                <el-date-picker
                  v-model="addContractFrom.date_signing"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="签订日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期起" prop="date_signing_start">
                <el-date-picker
                  v-model="addContractFrom.date_signing_start"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期起"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期止" prop="date_signing_end">
                <el-date-picker
                  v-model="addContractFrom.date_signing_end"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期止"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同状态：" prop="contract_status">
                <el-select
                  v-model="addContractFrom.contract_status"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="执行中"></el-option>
                  <el-option :value="2" label="已到期"></el-option>
                  <el-option :value="3" label="未执行"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同备注：" prop="contract_note" style="width: 100%!important;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="addContractFrom.contract_note">
                </el-input>
              </el-form-item>
              <el-form-item label="合同附件：" prop="contract_file" style="width: 100%!important;">
                <el-upload
                  :action="actionHost + '/api/upload/tyc/uploadRelated'"
                  :headers="uploadHeader"
                  multiple
                  :on-success="handleWorkSuccess"
                  :on-preview="handleWorkPreview"
                  :on-remove="handleWorkRemove"
                  :on-change="handleAvatarChange"
                  :file-list="contractFileList"
                  :limit="1"
                  list-type="picture">
                  <el-link type="primary">上传合同凭证</el-link>
                </el-upload>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addContractFrom')"
                size="mini"
                style="float: right;margin-right: 5px"
              >保 存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="family_member" label="家庭成员">
            <div class="dplx-item-title item-title">家庭成员</div>
            <el-table
              border
              :data="addFamilyMemberFrom"
              :row-class-name="rowClassName"
              @selection-change="handleDetailSelectionChange"
              ref="tb"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh" width="50"></el-table-column>
              <el-table-column label="关系" align="center" prop="relationship" width="180">
                <template slot-scope="scope">
                  <el-select
                    v-model="addFamilyMemberFrom[scope.row.xh-1].relationship"
                    placeholder="请选择"
                    size="mini">
                    <el-option
                      v-for="item in relationshipOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="姓名" align="center" prop="family_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addFamilyMemberFrom[scope.row.xh-1].family_name" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="证件类型" align="center" prop="family_id_type" width="180">
                <template slot-scope="scope">
                  <el-select v-model="addFamilyMemberFrom[scope.row.xh-1].family_id_type" placeholder="请选择" size="mini">
                    <el-option
                      v-for="item in idTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="证件号码" align="center" prop="family_id_number" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addFamilyMemberFrom[scope.row.xh-1].family_id_number" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="出生日期" align="center" prop="family_birth" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addFamilyMemberFrom[scope.row.xh-1].family_birth"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="出生日期"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="国籍(地区)" align="center" prop="family_nationality" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addFamilyMemberFrom[scope.row.xh-1].family_nationality" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="工作单位" align="center" prop="family_work_unit" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addFamilyMemberFrom[scope.row.xh-1].family_work_unit" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" prop="family_remarks" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addFamilyMemberFrom[scope.row.xh-1].family_remarks" size="mini"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addFamilyMemberFun"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails"
            >删除</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails"
            >清空</el-button>
            <el-button
              type="primary"
              @click="submitAddForm('addFamilyMemberFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="educational_experience" label="教育经历">
            <div class="dplx-item-title item-title">教育经历</div>
            <el-table
              border
              :data="addEducationalFrom"
              :row-class-name="rowClassName7"
              @selection-change="handleDetailSelectionChange7"
              ref="tb7"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh7" width="50"></el-table-column>
              <el-table-column label="入学时间" align="center" prop="admission_time" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addEducationalFrom[scope.row.xh7-1].admission_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入学时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="毕业时间" align="center" prop="graduation_time" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addEducationalFrom[scope.row.xh7-1].graduation_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="毕业时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="毕业学校" align="center" prop="school" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addEducationalFrom[scope.row.xh7-1].school" size="mini" placeholder="毕业学校"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="所学专业" align="center" prop="major" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addEducationalFrom[scope.row.xh7-1].major" size="mini" placeholder="所学专业"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails7"
            >删除</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails7"
            >清空</el-button>
            <el-button
              type="primary"
              @click="submitAddForm('addEducationalFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="work_experience" label="工作经历">
            <div class="dplx-item-title item-title">工作经历</div>
            <el-table
              border
              :data="addWorkExperienceFrom"
              :row-class-name="rowClassName8"
              @selection-change="handleDetailSelectionChange8"
              ref="tb7"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh8" width="50"></el-table-column>
              <el-table-column label="入职日期" align="center" prop="staff_reg_at" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addWorkExperienceFrom[scope.row.xh8-1].staff_reg_at"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="离职日期" align="center" prop="date_departure" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addWorkExperienceFrom[scope.row.xh8-1].date_departure"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="离职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="公司名称" align="center" prop="company_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addWorkExperienceFrom[scope.row.xh8-1].company_name" size="mini" placeholder="公司名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="担任职务" align="center" prop="hold_post" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addWorkExperienceFrom[scope.row.xh8-1].hold_post" size="mini" placeholder="担任职务"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun8"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails8"
            >删除</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails8"
            >清空</el-button>
            <el-button
              type="primary"
              @click="submitAddForm('addWorkExperienceFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="attached_data" label="附件资料">
            <div class="dplx-item-title item-title">附件资料</div>
            <el-table
              border
              :data="addAttachedDataFrom"
              :row-class-name="rowClassName9"
              @selection-change="handleDetailSelectionChange9"
              ref="tb7"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh9" width="50"></el-table-column>
              <el-table-column label="材料名称" align="center" prop="attached_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="addAttachedDataFrom[scope.row.xh9-1].attached_name" size="mini" placeholder="材料名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center" prop="attached">
                <template slot-scope="scope">
                  <el-upload
                    :action="actionHost + '/api/upload/tyc/uploadRelated'"
                    :headers="uploadHeader"
                    multiple
                    :on-success="(res,file)=>{handleWorkSuccessAttached(addAttachedDataFrom[scope.row.xh9-1].xh9,res,file)}"
                    :on-preview="handleWorkPreview2"
                    :on-remove="(file, fileList)=>{handleWorkRemove2(addAttachedDataFrom[scope.row.xh9-1].xh9, file, fileList)}"
                    :file-list="attachedFileList[scope.row.xh9-1]"
                    :limit="1"
                    list-type="picture">
                    <el-link type="primary">上传附件资料</el-link>
                  </el-upload>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun9"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails9"
            >删除</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails9"
            >清空</el-button>
            <el-button
              type="primary"
              @click="submitAddForm('addAttachedDataFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑员工"
      :visible.sync="updateStaffDrawer"
      direction="rtl"
      :before-close="handleUpStaffBeforeClose"
      size="55%"
    >
      <div class="m-tabs-content my_style" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs v-model="showNewTabPane"  :tab-position="tabPosition" type="border-card">
          <el-tab-pane name="first" label=基本信息>
            <el-form
              ref="updateStaffsFrom"
              :rules="addStaffRules"
              :model="updateStaffsFrom"
              label-width="100px"
              size="mini"
            >
              <div style="margin-left: 70%">
                人员状态：
                <el-radio-group
                  size="mini"
                  v-model="updateStaffsFrom.is_inservice"
                  @change="updateChange('updateStaffsFrom', 'is_inservice', '人员状态')"
                >
                  <el-radio-button :value=1 :label=1>在职</el-radio-button>
                  <el-radio-button :value=2 :label=2>离职</el-radio-button>
                </el-radio-group>
              </div>
              <div class="dplx-item-title item-title  small v-ewp-dc49ea38">基础信息</div>
              <el-form-item label="姓名：" prop="staff_name">
                <el-input
                  v-model="updateStaffsFrom.staff_name"
                  @change="updateChange('updateStaffsFrom', 'staff_name', '基础信息')"
                ></el-input>
              </el-form-item>
              <el-form-item label="工号：" prop="work_nnumber">
                <el-input
                  v-model="updateStaffsFrom.work_nnumber"
                  @change="updateChange('updateStaffsFrom', 'work_nnumber', '工号')"
                ></el-input>
              </el-form-item>
              <el-form-item label="证件类型：" prop="number_type">
                <el-select
                  v-model="updateStaffsFrom.number_type"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'number_type', '证件类型')"
                >
                  <el-option :value="1" label="居民身份证"></el-option>
                  <el-option :value="2" label="外国护照"></el-option>
                  <el-option :value="3" label="港澳居民来往内地通行证"></el-option>
                  <el-option :value="4" label="台湾居民来往大陆通行证"></el-option>
                  <el-option :value="5" label="外国人永久居留身份证(外国人永久居留证)"></el-option>
                  <el-option :value="6" label="中华人民共和国港澳居民居住证"></el-option>
                  <el-option :value="7" label="中华人民共和国台湾居民居住证"></el-option>
                  <el-option :value="8" label="中华人民共和国外国人工作许可证(A类)"></el-option>
                  <el-option :value="9" label="中华人民共和国外国人工作许可证(B类)"></el-option>
                  <el-option :value="10" label="中华人民共和国外国人工作许可证(C类)"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码：" prop="staff_id_number">
                <el-input
                  v-model="updateStaffsFrom.staff_id_number"
                  @change="updateChange('updateStaffsFrom', 'staff_id_number', '证件号码')"
                ></el-input>
              </el-form-item>
              <el-form-item label="其他证件类型：" prop="qt_number_type">
                <el-select
                  v-model="updateStaffsFrom.qt_number_type"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'qt_number_type', '其他证件类型')"
                >
                  <el-option :value="1" label="外国护照"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="其他证件证件号码：" prop="qt_staff_id_number">
                <el-input
                  v-model="updateStaffsFrom.qt_staff_id_number"
                  @change="updateChange('updateStaffsFrom', 'qt_staff_id_number', '其他证件证件号码')"
                ></el-input>
              </el-form-item>
              <el-form-item label="任职受雇从业类型：" prop="type_employment">
                <el-select
                  v-model="updateStaffsFrom.type_employment"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'type_employment', '任职受雇从业类型')"
                >
                  <el-option :value="1" label="雇员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                  <el-option :value="3" label="证券经纪人"></el-option>
                  <el-option :value="4" label="实习学生(全日制学历教育)"></el-option>
                  <el-option :value="5" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职年度就业情形：" prop="employment_situation">
                <el-select
                  v-model="updateStaffsFrom.employment_situation"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'employment_situation', '入职年度就业情形')"
                >
                  <el-option :value="1" label="当年首次入职其他人员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号码：" prop="staff_phone">
                <el-input
                  v-model="updateStaffsFrom.staff_phone"
                  @change="updateChange('updateStaffsFrom', 'staff_phone', '手机号码')"
                ></el-input>
              </el-form-item>
              <el-form-item label="国籍：" prop="nationality">
                <el-input
                  v-model="updateStaffsFrom.nationality"
                  @change="updateChange('updateStaffsFrom', 'nationality', '国籍')"
                ></el-input>
              </el-form-item>
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  v-model="updateStaffsFrom.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="出生日期"
                  @change="updateChange('updateStaffsFrom', 'birthday', '出生日期')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="性别：" prop="gender">
                <el-select
                  v-model="updateStaffsFrom.gender"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'gender', '性别')"
                >
                  <el-option :value="1" label="男"></el-option>
                  <el-option :value="2" label="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="入职时间："
                prop="staff_reg_at">
                <el-date-picker
                  v-model="updateStaffsFrom.staff_reg_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择入职时间"
                  @change="updateChange('updateStaffsFrom', 'staff_reg_at', '选择入职时间')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否扣除减除费用：" prop="deduction_expenses">
                <el-select
                  v-model="updateStaffsFrom.deduction_expenses"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'deduction_expenses', '是否扣除减除费用')"
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="2" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="离职时间："
                prop="staff_leave_at"
              >
                <el-date-picker
                  v-model="updateStaffsFrom.staff_leave_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择离职时间"
                  @change="updateChange('updateStaffsFrom', 'staff_leave_at', '选择离职时间')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="籍贯：" prop="native_place">
                <el-input
                  v-model="updateStaffsFrom.native_place"
                  @change="updateChange('updateStaffsFrom', 'native_place', '籍贯')"
                ></el-input>
              </el-form-item>
              <el-form-item label="婚姻状况：" prop="marital_status">
                <el-select
                  v-model="updateStaffsFrom.marital_status"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'marital_status', '婚姻状况')"
                >
                  <el-option :value="1" label="未婚"></el-option>
                  <el-option :value="2" label="已婚"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌：" prop="political_status">
                <el-select
                  v-model="updateStaffsFrom.political_status"
                  size="mini"
                  clearable
                  @change="updateChange('updateStaffsFrom', 'political_status', '政治面貌')"
                >
                  <el-option :value="1" label="群众"></el-option>
                  <el-option :value="2" label="党员"></el-option>
                  <el-option :value="3" label="共青团员"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="in_office" label="任职信息">
            <div class="dplx-item-title item-title">任职信息</div>
            <el-form
              ref="updateInOfficeFrom"
              :rules="addInOfficeFromRules"
              :model="updateInOfficeFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="员工类型：" prop="type_employee">
                <el-select
                  v-model="updateInOfficeFrom.type_employee"
                  size="mini"
                  clearable
                  @change="updateChange('updateInOfficeFrom', 'type_employee', '员工类型')"
                >
                  <el-option :value="1" label="管理人员"></el-option>
                  <el-option :value="2" label="销售人员"></el-option>
                  <el-option :value="3" label="研发人员"></el-option>
                  <el-option :value="4" label="车间人员"></el-option>
                  <el-option :value="5" label="临时人员"></el-option>
                  <el-option :value="6" label="普通人员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="组别：" prop="employees_group">
                <el-input
                  v-model="updateInOfficeFrom.employees_group"
                  @change="updateChange('updateInOfficeFrom', 'employees_group', '组别')"
                ></el-input>
              </el-form-item>
              <el-form-item label="岗位：" prop="jobs">
                <el-input
                  v-model="updateInOfficeFrom.jobs"
                  @change="updateChange('updateInOfficeFrom', 'jobs', '岗位')"
                ></el-input>
              </el-form-item>
              <el-form-item label="工作性质：" prop="nature_work">
                <el-select
                  v-model="updateInOfficeFrom.nature_work"
                  size="mini"
                  clearable
                  @change="updateChange('updateInOfficeFrom', 'nature_work', '工作性质')"
                >
                  <el-option :value="1" label="全职"></el-option>
                  <el-option :value="2" label="兼职"></el-option>
                  <el-option :value="3" label="实习"></el-option>
                  <el-option :value="4" label="劳务"></el-option>
                  <el-option :value="5" label="劳务派遣"></el-option>
                  <el-option :value="6" label="退休返聘"></el-option>
                  <el-option :value="7" label="合同工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工龄：" prop="length_service">
                <el-input
                  v-model="updateInOfficeFrom.length_service"
                  @change="updateChange('updateInOfficeFrom', 'length_service', '工龄')"
                ></el-input>
              </el-form-item>
              <el-form-item label="试用状态：" prop="trial_status">
                <el-select
                  v-model="updateInOfficeFrom.trial_status"
                  size="mini"
                  clearable
                  @change="updateChange('updateInOfficeFrom', 'trial_status', '试用状态')"
                >
                  <el-option :value="1" label="适用中"></el-option>
                  <el-option :value="2" label="已转正"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="试用期：" prop="probation_period">
                <el-select
                  v-model="updateInOfficeFrom.probation_period"
                  size="mini"
                  clearable
                  @change="updateChange('updateInOfficeFrom', 'probation_period', '试用期')"
                >
                  <el-option :value="0" label="无试用期"></el-option>
                  <el-option :value="1" label="一个月"></el-option>
                  <el-option :value="2" label="二个月"></el-option>
                  <el-option :value="3" label="三个月"></el-option>
                  <el-option :value="4" label="四个月"></el-option>
                  <el-option :value="5" label="五个月"></el-option>
                  <el-option :value="6" label="六个月"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转正日期：" prop="date_conversion">
                <el-date-picker
                  v-model="updateInOfficeFrom.date_conversion"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="转正日期"
                  @change="updateChange('updateInOfficeFrom', 'date_conversion', '转正日期')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="QQ号码：" prop="qq_number">
                <el-input
                  v-model="updateInOfficeFrom.qq_number"
                  @change="updateChange('updateInOfficeFrom', 'qq_number', 'QQ号码')"
                ></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人：" prop="emergency_person">
                <el-input
                  v-model="updateInOfficeFrom.emergency_person"
                  @change="updateChange('updateInOfficeFrom', 'emergency_person', '紧急联系人')"
                ></el-input>
              </el-form-item>
              <el-form-item label="紧急联系电话：" prop="emergency_phone">
                <el-input
                  v-model="updateInOfficeFrom.emergency_phone"
                  @change="updateChange('updateInOfficeFrom', 'emergency_phone', '紧急联系电话')"
                ></el-input>
              </el-form-item>
              <el-form-item label="薪资停发月份：" prop="salary_suspension">
                <el-date-picker
                  v-model="updateInOfficeFrom.salary_suspension"
                  type="month"
                  placeholder="薪资停发月份"
                  @change="updateChange('updateInOfficeFrom', 'salary_suspension', '薪资停发月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="club_discontinuation">
                <el-date-picker
                  v-model="updateInOfficeFrom.club_discontinuation"
                  type="month"
                  placeholder="社保停缴月份"
                  @change="updateChange('updateInOfficeFrom', 'club_discontinuation', '社保停缴月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金停缴月份：" prop="provident_discontinuation">
                <el-date-picker
                  v-model="updateInOfficeFrom.provident_discontinuation"
                  type="month"
                  placeholder="公积金停缴月份"
                  @change="updateChange('updateInOfficeFrom', 'provident_discontinuation', '公积金停缴月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="离职性质：" prop="nature_resignation">
                <el-select
                  v-model="updateInOfficeFrom.nature_resignation"
                  size="mini"
                  clearable
                  @change="updateChange('updateInOfficeFrom', 'nature_resignation', '离职性质')"
                >
                  <el-option :value="1" label="家庭原因"></el-option>
                  <el-option :value="2" label="身体原因"></el-option>
                  <el-option :value="3" label="薪资原因"></el-option>
                  <el-option :value="4" label="交通不便"></el-option>
                  <el-option :value="5" label="工作压力"></el-option>
                  <el-option :value="6" label="管理问题"></el-option>
                  <el-option :value="7" label="无晋升机会"></el-option>
                  <el-option :value="8" label="职业规划"></el-option>
                  <el-option :value="9" label="合同到期放弃续约"></el-option>
                  <el-option :value="10" label="试用期内辞职"></el-option>
                  <el-option :value="11" label="违反工商条例"></el-option>
                  <el-option :value="12" label="组织调整/裁员"></el-option>
                  <el-option :value="13" label="业绩不达标辞退"></el-option>
                  <el-option :value="14" label="其他原因"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="离职原因：" prop="reasons_leaving">
                <el-input
                  v-model="updateInOfficeFrom.reasons_leaving"
                  @change="updateChange('updateInOfficeFrom', 'reasons_leaving', '离职原因')"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="securityd_accum" label="社保公积金">
            <div class="dplx-item-title item-title">社保公积金</div>
            <el-form
              ref="updateSocialSecurityFrom"
              :model="updateSocialSecurityFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="参保方案：" prop="insurance_scheme">
                <el-select
                  v-model="updateSocialSecurityFrom.insurance_scheme"
                  size="mini"
                  clearable
                  @change="updateChange('updateSocialSecurityFrom', 'insurance_scheme', '参保方案')"
                >
                  <el-option :value="1" label="上海社保工商0.16%"></el-option>
                  <el-option :value="2" label="上海社保工商00.256%"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参保城市：" prop="insured_city">
                <el-input
                  v-model="updateSocialSecurityFrom.insured_city"
                  @change="updateChange('updateSocialSecurityFrom', 'insured_city', '参保城市')"
                ></el-input>
              </el-form-item>
              <el-form-item label="户籍性质：" prop="registered_the">
                <el-select
                  v-model="updateSocialSecurityFrom.registered_the"
                  size="mini"
                  clearable
                  @change="updateChange('updateSocialSecurityFrom', 'registered_the', '户籍性质')"
                >
                  <el-option :value="1" label="城镇户籍"></el-option>
                  <el-option :value="2" label="农村户籍"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否缴纳社保：" prop="is_secuity" style="width: 100%!important;">
                <el-radio-group
                  v-model="updateSocialSecurityFrom.is_secuity"
                  size="mini"
                  @change="updateChange('updateSocialSecurityFrom', 'is_secuity', '是否缴纳社保')"
                >
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="人社证件类型：" prop="staff_id_type">
                <el-select
                  v-model="updateSocialSecurityFrom.staff_id_type"
                  size="mini"
                  clearable
                  @change="updateChange('updateSocialSecurityFrom', 'staff_id_type', '人社证件类型')"
                >
                  <el-option :value="1" label="居民身份证"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人社证件号码：" prop="staff_id_number">
                <el-input
                  v-model="updateSocialSecurityFrom.staff_id_number"
                  @change="updateChange('updateSocialSecurityFrom', 'staff_id_number', '人社证件号码')"
                ></el-input>
              </el-form-item>
              <el-form-item label="开始参保月份：" prop="month_enrollment">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.month_enrollment"
                  type="month"
                  placeholder="开始参保月份"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'month_enrollment', '人社证件号码')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="ting_month_enrollment">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.ting_month_enrollment"
                  type="month"
                  placeholder="社保停缴月份"
                  @change="updateChange('updateSocialSecurityFrom', 'ting_month_enrollment', '社保停缴月份')"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保补缴月份：" prop="bu_month_enrollment">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.bu_month_enrollment"
                  type="month"
                  placeholder="社保补缴月份"
                  @change="updateChange('updateSocialSecurityFrom', 'bu_month_enrollment', '社保补缴月份')"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保账号：" prop="security_number">
                <el-input
                  v-model="updateSocialSecurityFrom.security_number"
                  @change="updateChange('updateSocialSecurityFrom', 'security_number', '社保账号')"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="社保个人编号：" prop="security_personal_number ">
                <el-input
                  v-model="updateSocialSecurityFrom.security_personal_number"
                  @change="updateChange('updateSocialSecurityFrom', 'security_personal_number', '社保个人编号')"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="社保缴纳基数："
                prop="secuity_base"
              >
                <el-input
                  v-model="updateSocialSecurityFrom.secuity_base"
                  @change="updateChange('updateSocialSecurityFrom', 'secuity_base', '社保缴纳基数')"
                  :disabled="updateSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否缴纳公积金：" prop="is_accum" style="width: 100%!important;">
                <el-radio-group
                  v-model="updateSocialSecurityFrom.is_accum"
                  size="mini"
                  @change="updateChange('updateSocialSecurityFrom', 'is_accum', '是否缴纳公积金')"
                >
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开始缴纳月份：" prop="accum_starting_month">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.accum_starting_month"
                  type="month"
                  placeholder="开始缴纳月份"
                  :disabled="updateSocialSecurityFrom.is_accum === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'accum_starting_month', '开始缴纳月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="停止缴存月份：" prop="accum_ting_starting_month">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.accum_ting_starting_month"
                  type="month"
                  placeholder="停止缴存月份"
                  :disabled="updateSocialSecurityFrom.is_accum === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'accum_ting_starting_month', '停止缴存月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金补缴月份：" prop="accum_bu_starting_month">
                <el-date-picker
                  v-model="updateSocialSecurityFrom.accum_bu_starting_month"
                  type="month"
                  placeholder="公积金补缴月份"
                  :disabled="updateSocialSecurityFrom.is_accum === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'picker', '公积金补缴月份')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金个人账号：" prop="accum_account">
                <el-input
                  v-model="updateSocialSecurityFrom.accum_account"
                  :disabled="updateSocialSecurityFrom.accum_account === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'accum_account', '公积金个人账号')"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="缴纳基数"
                prop="accum_base"
              >
                <el-input
                  v-model="updateSocialSecurityFrom.accum_base"
                  :disabled="updateSocialSecurityFrom.is_accum === 1 ? true : false"
                  @change="updateChange('updateSocialSecurityFrom', 'accum_base', '缴纳基数')"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="tax_related" label="涉税信息">
            <div class="dplx-item-title item-title">涉税信息</div>
            <el-form
              ref="updateTaxRelatedFrom"
              :model="updateTaxRelatedFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="开户银行：" prop="bank_account">
                <el-input
                  v-model="updateTaxRelatedFrom.bank_account"
                  @change="updateChange('updateTaxRelatedFrom', 'bank_account', '开户银行')"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" prop="bank_number">
                <el-input
                  v-model="updateTaxRelatedFrom.bank_number"
                  @change="updateChange('updateTaxRelatedFrom', 'bank_number', '银行账号')"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户行省份：" prop="bank_account_province">
                <el-input
                  v-model="updateTaxRelatedFrom.bank_account_province"
                  @change="updateChange('updateTaxRelatedFrom', 'bank_account_province', '开户行省份')"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行卡状态：" prop="bank_card_status">
                <el-input
                  v-model="updateTaxRelatedFrom.bank_card_status"
                  @change="updateChange('updateTaxRelatedFrom', 'bank_card_status', '银行卡状态')"
                ></el-input>
              </el-form-item>
              <el-form-item label="个人投资额：" prop="personal_investment">
                <el-input
                  v-model.number="updateTaxRelatedFrom.personal_investment"
                  @change="updateChange('updateTaxRelatedFrom', 'personal_investment', '个人投资额')"
                ></el-input>
              </el-form-item>
              <el-form-item label="个人投资比例(%)：" prop="personal_investment_bl">
                <el-input
                  v-model.number="updateTaxRelatedFrom.personal_investment_bl"
                  @change="updateChange('updateTaxRelatedFrom', 'personal_investment_bl', '个人投资比例(%)')"
                ></el-input>
              </el-form-item>
              <el-form-item label="特殊情况：" prop="special" style="width: 100%!important;">
                <el-radio v-model="updateTaxRelatedFrom.special" :label=1 @change="updateChange('updateTaxRelatedFrom', 'special', '特殊情况')">残疾</el-radio>
                <el-radio v-model="updateTaxRelatedFrom.special" :label=2 @change="updateChange('updateTaxRelatedFrom', 'special', '特殊情况')">烈属</el-radio>
                <el-radio v-model="updateTaxRelatedFrom.special" :label=3 @change="updateChange('updateTaxRelatedFrom', 'special', '特殊情况')">孤老</el-radio>
              </el-form-item>
              <el-form-item
                label="残疾证号"
                prop="disability_number"
              >
                <el-input
                  v-model="updateTaxRelatedFrom.disability_number"
                  :disabled="updateTaxRelatedFrom.special === 1 ? false : true "
                  @change="updateChange('updateTaxRelatedFrom', 'disability_number', '残疾证号')"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="烈属证号："
                prop="is_martyrs_family_number">
                <el-input
                  v-model="updateTaxRelatedFrom.is_martyrs_family_number"
                  :disabled="updateTaxRelatedFrom.special === 2 ? false : true "
                  @change="updateChange('updateTaxRelatedFrom', 'is_martyrs_family_number', '烈属证号')"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" prop="email">
                <el-input v-model="updateTaxRelatedFrom.email" @change="updateChange('updateTaxRelatedFrom', 'email', '电子邮箱')"></el-input>
              </el-form-item>
              <el-form-item label="学历：" prop="formal_schooling">
                <el-select
                  v-model="updateTaxRelatedFrom.formal_schooling"
                  size="mini"
                  clearable
                  @change="updateChange('updateTaxRelatedFrom', 'formal_schooling', '学历')"
                >
                  <el-option :value="1" label="研究生"></el-option>
                  <el-option :value="2" label="大学本科"></el-option>
                  <el-option :value="3" label="大学本科以下"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职务：" prop="position">
                <el-select
                  v-model="updateTaxRelatedFrom.position"
                  size="mini"
                  clearable
                  @change="updateChange('updateTaxRelatedFrom', 'position', '职务')"
                >
                  <el-option :value="1" label="高层"></el-option>
                  <el-option :value="2" label="普通"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="纳税人识别号：" prop="taxpayers_number">
                <el-input v-model="updateTaxRelatedFrom.taxpayers_number" @change="updateChange('updateTaxRelatedFrom', 'taxpayers_number', '纳税人识别号')"></el-input>
              </el-form-item>
              <el-form-item label="备注：" prop="note" style="width: 100%!important;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="updateTaxRelatedFrom.note"
                  @change="updateChange('updateTaxRelatedFrom', 'note', '备注')">
                </el-input>
              </el-form-item>
              <el-form-item label="经常居住地：" prop="address_permanent">
                <el-input v-model="updateTaxRelatedFrom.address_permanent" @change="updateChange('address_permanent', 'bank_number', '经常居住地')"></el-input>
              </el-form-item>
              <el-form-item label="居住街道：" prop="address_street">
                <el-input v-model="updateTaxRelatedFrom.address_street" @change="updateChange('address_street', 'bank_number', '居住街道')"></el-input>
              </el-form-item>
              <el-form-item label="居住详细地址：" prop="address_full" style="width: 100%!important;">
                <el-input v-model="updateTaxRelatedFrom.address_full" @change="updateChange('updateTaxRelatedFrom', 'address_full', '居住详细地址')"></el-input>
              </el-form-item>
              <el-form-item label="户籍所在地：" prop="place_residence">
                <el-input v-model="updateTaxRelatedFrom.place_residence" @change="updateChange('updateTaxRelatedFrom', 'place_residence', '户籍所在地')"></el-input>
              </el-form-item>
              <el-form-item label="户籍街道：" prop="place_residence_street">
                <el-input v-model="updateTaxRelatedFrom.place_residence_street" @change="updateChange('updateTaxRelatedFrom', 'place_residence_street', '户籍街道')"></el-input>
              </el-form-item>
              <el-form-item label="户籍详细地址：" prop="place_residence_full" style="width: 100%!important;">
                <el-input v-model="updateTaxRelatedFrom.place_residence_full" @change="updateChange('updateTaxRelatedFrom', 'place_residence_full', '户籍详细地址')"></el-input>
              </el-form-item>
              <el-form-item label="联系地址：" prop="address_contact">
                <el-input v-model="updateTaxRelatedFrom.address_contact" @change="updateChange('updateTaxRelatedFrom', 'address_contact', '联系地址')"></el-input>
              </el-form-item>
              <el-form-item label="联系街道：" prop="address_contact_street">
                <el-input v-model="updateTaxRelatedFrom.address_contact_street" @change="updateChange('updateTaxRelatedFrom', 'address_contact_street', '联系街道')"></el-input>
              </el-form-item>
              <el-form-item label="联系详细地址：" prop="address_contact_full" style="width: 100%!important;">
                <el-input v-model="updateTaxRelatedFrom.address_contact_full" @change="updateChange('updateTaxRelatedFrom', 'address_contact_full', '联系详细地址')"></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="contract" label="合同信息">
            <div class="dplx-item-title item-title">合同信息</div>
            <el-form
              ref="updateContractFrom"
              :model="updateContractFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="合同类型：" prop="contract_type">
                <el-select
                  v-model="updateContractFrom.contract_type"
                  size="mini"
                  clearable
                  @change="updateChange('updateContractFrom', 'contract_type', '合同类型')"
                >
                  <el-option :value="1" label="固定期限劳动合同"></el-option>
                  <el-option :value="2" label="无固定期限劳动合同"></el-option>
                  <el-option :value="3" label="实习协议"></el-option>
                  <el-option :value="4" label="劳务合同"></el-option>
                  <el-option :value="5" label="返聘协议"></el-option>
                  <el-option :value="6" label="劳务派遣合同"></el-option>
                  <el-option :value="7" label="借调合同"></el-option>
                  <el-option :value="0" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同编号：" prop="contract_number">
                <el-input
                  v-model="updateContractFrom.contract_number"
                  @change="updateChange('updateContractFrom', 'contract_number', '合同编号')"
                ></el-input>
              </el-form-item>
              <el-form-item label="合同期限：" prop="contract_term">
                <el-select
                  v-model="updateContractFrom.contract_term"
                  size="mini"
                  clearable
                  @change="updateChange('updateContractFrom', 'contract_term', '合同期限')"
                >
                  <el-option :value="1" label="1年"></el-option>
                  <el-option :value="2" label="2年"></el-option>
                  <el-option :value="3" label="3年"></el-option>
                  <el-option :value="4" label="4年"></el-option>
                  <el-option :value="5" label="5年"></el-option>
                  <el-option :value="6" label="6年"></el-option>
                  <el-option :value="7" label="7年"></el-option>
                  <el-option :value="8" label="8年"></el-option>
                  <el-option :value="9" label="9年"></el-option>
                  <el-option :value="10" label="10年"></el-option>
                  <el-option :value="0" label="永久"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签订日期" prop="date_signing">
                <el-date-picker
                  v-model="updateContractFrom.date_signing"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="签订日期"
                  @change="updateChange('updateContractFrom', 'date_signing', '签订日期')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期起" prop="date_signing_start">
                <el-date-picker
                  v-model="updateContractFrom.date_signing_start"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期起"
                  @change="updateChange('updateContractFrom', 'date_signing_start', '合同期起')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期止" prop="date_signing_end">
                <el-date-picker
                  v-model="updateContractFrom.date_signing_end"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期止"
                  @change="updateChange('updateContractFrom', 'date_signing_end', '合同期止')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同状态：" prop="contract_status">
                <el-select
                  v-model="updateContractFrom.contract_status"
                  size="mini"
                  clearable
                  @change="updateChange('updateContractFrom', 'contract_status', '合同状态')"
                >
                  <el-option :value="1" label="执行中"></el-option>
                  <el-option :value="2" label="已到期"></el-option>
                  <el-option :value="3" label="未执行"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同备注：" prop="contract_note" style="width: 100%!important;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="updateContractFrom.contract_note"
                  @change="updateChange('updateContractFrom', 'contract_note', '合同备注')">
                </el-input>
              </el-form-item>
              <el-form-item label="合同附件：" prop="contract_file" style="width: 100%!important;">
                <el-upload
                  :action="actionHost + '/api/upload/staff/uploadRelated?insetId='+ this.insetId"
                  :headers="uploadHeader"
                  multiple
                  :on-success="handleWorkSuccessUpdate"
                  :on-preview="handleWorkPreview"
                  :on-remove="handleWorkRemove"
                  :on-change="handleAvatarChange"
                  :file-list="contractFileList"
                  :limit="1"
                  list-type="picture">
                  <el-link type="primary">上传合同凭证</el-link>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="family_member" label="家庭成员">
            <div class="dplx-item-title item-title">家庭成员</div>
            <el-table
              border
              :data="updateFamilyMemberFrom"
              :row-class-name="rowClassName11"
              @selection-change="handleDetailSelectionChange11"
              ref="tb11"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh11" width="50"></el-table-column>
              <el-table-column label="关系" align="center" prop="relationship" width="180">
                <template slot-scope="scope">
                  <el-select
                    v-model="updateFamilyMemberFrom[scope.row.xh11-1].relationship"
                    placeholder="请选择"
                    size="mini">
                    <el-option
                      v-for="item in relationshipOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="姓名" align="center" prop="family_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_name" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="证件类型" align="center" prop="family_id_type" width="180">
                <template slot-scope="scope">
                  <el-select v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_id_type" placeholder="请选择" size="mini">
                    <el-option
                      v-for="item in idTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="证件号码" align="center" prop="family_id_number" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_id_number" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="出生日期" align="center" prop="family_birth" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_birth"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="出生日期"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="国籍(地区)" align="center" prop="family_nationality" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_nationality" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="工作单位" align="center" prop="family_work_unit" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_work_unit" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" prop="family_remarks" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateFamilyMemberFrom[scope.row.xh11-1].family_remarks" size="mini"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addFamilyMemberFun11"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails11()"
            >删除</el-button>
            <el-button
              type="primary"
              @click="updateStaffFun('updateFamilyMemberFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="educational_experience" label="教育经历">
            <div class="dplx-item-title item-title">教育经历</div>
            <el-table
              border
              :data="updateEducationalFrom"
              :row-class-name="rowClassName12"
              @selection-change="handleDetailSelectionChange12"
              ref="tb12"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh12" width="50"></el-table-column>
              <el-table-column label="入学时间" align="center" prop="admission_time" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="updateEducationalFrom[scope.row.xh12-1].admission_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入学时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="毕业时间" align="center" prop="graduation_time" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="updateEducationalFrom[scope.row.xh12-1].graduation_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="毕业时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="毕业学校" align="center" prop="school" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateEducationalFrom[scope.row.xh12-1].school" size="mini" placeholder="毕业学校"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="所学专业" align="center" prop="major" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateEducationalFrom[scope.row.xh12-1].major" size="mini" placeholder="所学专业"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun12"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails12"
            >删除</el-button>
            <el-button
              type="primary"
              @click="updateStaffFun('updateEducationalFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="work_experience" label="工作经历">
            <div class="dplx-item-title item-title">工作经历</div>
            <el-table
              border
              :data="updateWorkExperienceFrom"
              :row-class-name="rowClassName13"
              @selection-change="handleDetailSelectionChange13"
              ref="tb7"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh13" width="50"></el-table-column>
              <el-table-column label="入职日期" align="center" prop="staff_reg_at" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="updateWorkExperienceFrom[scope.row.xh13-1].staff_reg_at"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="离职日期" align="center" prop="date_departure" width="180">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="updateWorkExperienceFrom[scope.row.xh13-1].date_departure"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="离职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="公司名称" align="center" prop="company_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateWorkExperienceFrom[scope.row.xh13-1].company_name" size="mini" placeholder="公司名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="担任职务" align="center" prop="hold_post" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateWorkExperienceFrom[scope.row.xh13-1].hold_post" size="mini" placeholder="担任职务"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun13"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails13"
            >删除</el-button>
            <el-button
              type="primary"
              @click="updateStaffFun('updateWorkExperienceFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
          <el-tab-pane name="attached_data" label="附件资料">
            <div class="dplx-item-title item-title">附件资料</div>
            <el-table
              border
              :data="updateAttachedDataFrom"
              :row-class-name="rowClassName14"
              @selection-change="handleDetailSelectionChange14"
              ref="tb14"
              style="width:850px;margin-bottom: 20px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column label="序号" align="center" prop="xh14" width="50"></el-table-column>
              <el-table-column label="材料名称" align="center" prop="attached_name" width="180">
                <template slot-scope="scope">
                  <el-input v-model="updateAttachedDataFrom[scope.row.xh14-1].attached_name" size="mini" placeholder="材料名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center" prop="attached">
                <template slot-scope="scope">
                  <el-upload
                    :action="actionHost + '/api/upload/tyc/uploadRelated'"
                    :headers="uploadHeader"
                    multiple
                    :on-success="(res,file)=>{handleWorkSuccessAttached14(updateAttachedDataFrom[scope.row.xh14-1].xh14,res,file)}"
                    :on-preview="handleWorkPreview2"
                    :on-remove="(file, fileList)=>{handleWorkRemove14(updateAttachedDataFrom[scope.row.xh14-1].xh14, file, fileList)}"
                    :file-list="attachedFileList[scope.row.xh14-1]"
                    :limit="1"
                    list-type="picture">
                    <el-link type="primary">上传附件资料</el-link>
                  </el-upload>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun14"
            >添加</el-button>
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails14"
            >删除</el-button>
            <el-button
              type="primary"
              @click="updateStaffFun('updateAttachedDataFrom')"
              size="mini"
              style="float: right;margin-right: 5px"
            >保 存</el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'staffMsgs',
  data () {
    return {

      // 表格数据
      colOptions: [
        '编号',
        '姓名',
        '工号',
        '证件类型',
        '证件号码',
        '任职受雇从业类型',
        '入职年度就业情形',
        '手机号码',
        '国籍(地区)',
        '出生日期',
        '性别',
        '入职日期',
        '是否扣除减除费用',
        '离职日期',
        '籍贯',
        '婚姻状况',
        '政治面貌',
        '员工类型',
        '组别',
        '岗位',
        '工作性质',
        '工龄',
        '试用状态',
        '试用期',
        '转正日期',
        'QQ号码',
        '紧急联系人',
        '紧急联系电话',
        '薪资停发月份',
        '社保停缴月份',
        '公积金停缴月份',
        '离职性质',
        '离职原因',
        '参保方案 ',
        '参保城市',
        '是否缴纳社保',
        '人社证件类型',
        '人社证件号码',
        '开始参保月份',
        '社保停缴月份',
        '社保补缴月份',
        '社保账号',
        '社保个人编号',
        '是否缴纳公积金',
        '开始缴纳月份',
        '停止缴存月份',
        '公积金补缴月份',
        '公积金个人账号',
        '开户银行',
        '银行账号',
        '开户行省份',
        '银行卡状态',
        '个人投资额',
        '个人投资比例(%)',
        '特殊情形',
        '残疾证号',
        '烈属证号',
        '电子邮箱',
        '学历',
        '职务',
        '纳税人识别号',
        '备注',
        '经常居住地',
        '居住街道',
        '居住详细地址',
        '户籍所在地',
        '户籍街道',
        '户籍详细地址',
        '联系地址',
        '联系街道',
        '联系详细地址',
        '是否在职'
      ],
      colSelect: [
        '编号',
        '姓名',
        '工号',
        '证件类型',
        '证件号码',
        '任职受雇从业类型',
        '入职年度就业情形',
        '手机号码',
        '国籍(地区)',
        '出生日期',
        '性别',
        '入职日期',
        '是否扣除减除费用',
        '离职日期',
        '籍贯',
        '婚姻状况',
        '政治面貌',
        '员工类型',
        '组别',
        '岗位',
        '工作性质',
        '工龄',
        '试用状态',
        '试用期',
        '转正日期',
        'QQ号码',
        '紧急联系人',
        '紧急联系电话',
        '薪资停发月份',
        '社保停缴月份',
        '公积金停缴月份',
        '离职性质',
        '离职原因',
        '参保方案 ',
        '参保城市',
        '是否缴纳社保',
        '人社证件类型',
        '人社证件号码',
        '开始参保月份',
        '社保停缴月份',
        '社保补缴月份',
        '社保账号',
        '社保个人编号',
        '是否缴纳公积金',
        '开始缴纳月份',
        '停止缴存月份',
        '公积金补缴月份',
        '公积金个人账号',
        '开户银行',
        '银行账号',
        '开户行省份',
        '银行卡状态',
        '个人投资额',
        '个人投资比例(%)',
        '特殊情形',
        '残疾证号',
        '烈属证号',
        '电子邮箱',
        '学历',
        '职务',
        '纳税人识别号',
        '备注',
        '经常居住地',
        '居住街道',
        '居住详细地址',
        '户籍所在地',
        '户籍街道',
        '户籍详细地址',
        '联系地址',
        '联系街道',
        '联系详细地址',
        '是否在职'
      ],
      colData: [
        {title: '编号', istrue: true},
        {title: '姓名', istrue: true},
        {title: '工号', istrue: true},
        {title: '证件类型', istrue: true},
        {title: '证件号码', istrue: true},
        {title: '任职受雇从业类型', istrue: true},
        {title: '入职年度就业情形', istrue: true},
        {title: '手机号码', istrue: true},
        {title: '国籍(地区)', istrue: true},
        {title: '出生日期', istrue: true},
        {title: '性别', istrue: true},
        {title: '入职日期', istrue: true},
        {title: '是否扣除减除费用', istrue: true},
        {title: '离职日期', istrue: true},
        {title: '籍贯', istrue: true},
        {title: '婚姻状况', istrue: true},
        {title: '政治面貌', istrue: true},
        {title: '员工类型', istrue: true},
        {title: '组别', istrue: true},
        {title: '岗位', istrue: true},
        {title: '工作性质', istrue: true},
        {title: '工龄', istrue: true},
        {title: '试用状态', istrue: true},
        {title: '试用期', istrue: true},
        {title: '转正日期', istrue: true},
        {title: 'QQ号码', istrue: true},
        {title: '紧急联系人', istrue: true},
        {title: '紧急联系电话', istrue: true},
        {title: '薪资停发月份', istrue: true},
        {title: '社保停缴月份', istrue: true},
        {title: '公积金停缴月份', istrue: true},
        {title: '离职性质', istrue: true},
        {title: '离职原因', istrue: true},
        {title: '参保方案 ', istrue: true},
        {title: '参保城市', istrue: true},
        {title: '是否缴纳社保', istrue: true},
        {title: '人社证件类型', istrue: true},
        {title: '人社证件号码', istrue: true},
        {title: '开始参保月份', istrue: true},
        {title: '社保停缴月份', istrue: true},
        {title: '社保补缴月份', istrue: true},
        {title: '社保账号', istrue: true},
        {title: '社保个人编号', istrue: true},
        {title: '是否缴纳公积金', istrue: true},
        {title: '开始缴纳月份', istrue: true},
        {title: '停止缴存月份', istrue: true},
        {title: '公积金补缴月份', istrue: true},
        {title: '公积金个人账号', istrue: true},
        {title: '开户银行', istrue: true},
        {title: '银行账号', istrue: true},
        {title: '开户行省份', istrue: true},
        {title: '银行卡状态', istrue: true},
        {title: '个人投资额', istrue: true},
        {title: '个人投资比例(%)', istrue: true},
        {title: '特殊情形', istrue: true},
        {title: '残疾证号', istrue: true},
        {title: '烈属证号', istrue: true},
        {title: '电子邮箱', istrue: true},
        {title: '学历', istrue: true},
        {title: '职务', istrue: true},
        {title: '纳税人识别号', istrue: true},
        {title: '备注', istrue: true},
        {title: '经常居住地', istrue: true},
        {title: '居住街道', istrue: true},
        {title: '居住详细地址', istrue: true},
        {title: '户籍所在地', istrue: true},
        {title: '户籍街道', istrue: true},
        {title: '户籍详细地址', istrue: false},
        {title: '联系地址', istrue: false},
        {title: '联系街道', istrue: false},
        {title: '联系详细地址', istrue: true},
        {title: '是否在职', istrue: true}
      ],
      // 表头数据
      tableHeader: [
        {lable: '编号', key: 'id'},
        {lable: '姓名', key: 'staff_name'},
        {lable: '工号', key: 'work_nnumber'},
        {lable: '证件类型', key: 'number_type'},
        {lable: '证件号码', key: 'staff_id_number'},
        {lable: '任职受雇从业类型', key: 'type_employment'},
        {lable: '入职年度就业情形', key: 'employment_situation'},
        {lable: '手机号码', key: 'staff_phone'},
        {lable: '国籍(地区)', key: 'nationality'},
        {lable: '出生日期', key: 'birthday'},
        {lable: '性别', key: 'gender'},
        {lable: '入职日期', key: 'staff_reg_at'},
        {lable: '是否扣除减除费用', key: 'deduction_expenses'},
        {lable: '离职日期', key: 'staff_leave_at'},
        {lable: '籍贯', key: 'native_place'},
        {lable: '婚姻状况', key: 'marital_status'},
        {lable: '政治面貌', key: 'political_status'},
        {lable: '员工类型', key: 'type_employee'},
        {lable: '组别', key: 'employees_group'},
        {lable: '岗位', key: 'jobs'},
        {lable: '工作性质', key: 'nature_work'},
        {lable: '工龄', key: 'length_service'},
        {lable: '试用状态', key: 'trial_status'},
        {lable: '试用期', key: 'probation_period'},
        {lable: '转正日期', key: 'date_conversion'},
        {lable: 'QQ号码', key: 'qq_number'},
        {lable: '紧急联系人', key: 'emergency_person'},
        {lable: '紧急联系电话', key: 'emergency_phone'},
        {lable: '薪资停发月份', key: 'salary_suspension'},
        {lable: '社保停缴月份', key: 'club_discontinuation'},
        {lable: '公积金停缴月份', key: 'provident_discontinuation'},
        {lable: '离职性质', key: 'nature_resignation'},
        {lable: '离职原因', key: 'reasons_leaving'},
        {lable: '参保方案 ', key: 'insurance_scheme'},
        {lable: '参保城市', key: 'insured_city'},
        {lable: '是否缴纳社保', key: 'is_secuity'},
        {lable: '人社证件类型', key: 'staff_id_type'},
        {lable: '人社证件号码', key: 'staff_id_number'},
        {lable: '开始参保月份', key: 'month_enrollment'},
        {lable: '社保停缴月份', key: 'ting_month_enrollment'},
        {lable: '社保补缴月份', key: 'bu_month_enrollment'},
        {lable: '社保账号', key: 'security_number'},
        {lable: '社保个人编号', key: 'security_personal_number'},
        {lable: '是否缴纳公积金', key: 'is_accum'},
        {lable: '开始缴纳月份', key: 'accum_starting_month'},
        {lable: '停止缴存月份', key: 'accum_ting_starting_month'},
        {lable: '公积金补缴月份', key: 'accum_bu_starting_month'},
        {lable: '公积金个人账号', key: 'accum_account'},
        {lable: '开户银行', key: 'bank_account'},
        {lable: '银行账号', key: 'bank_number'},
        {lable: '开户行省份', key: 'bank_account_province'},
        {lable: '银行卡状态', key: 'bank_card_status'},
        {lable: '个人投资额', key: 'personal_investment'},
        {lable: '个人投资比例(%)', key: 'personal_investment_bl'},
        {lable: '特殊情形', key: 'special'},
        {lable: '残疾证号', key: 'disability_number'},
        {lable: '烈属证号', key: 'is_martyrs_family_number'},
        {lable: '电子邮箱', key: 'email'},
        {lable: '学历', key: 'formal_schooling'},
        {lable: '职务', key: 'position'},
        {lable: '纳税人识别号', key: 'taxpayers_number'},
        {lable: '备注', key: 'note'},
        {lable: '经常居住地', key: 'address_permanent'},
        {lable: '居住街道', key: 'address_street'},
        {lable: '居住详细地址', key: 'address_full'},
        {lable: '户籍所在地', key: 'place_residence'},
        {lable: '户籍街道', key: 'place_residence_street'},
        {lable: '户籍详细地址', key: 'place_residence_full'},
        {lable: '联系地址', key: 'address_contact'},
        {lable: '联系街道', key: 'address_contact_street'},
        {lable: '联系详细地址', key: 'address_contact_full'},
        {lable: '是否在职', key: 'is_inservice'}
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      delId: '',
      searchArr: {
        id: null
      },
      uploadHeader: { Authorization: localStorage.token },
      searchStaffMsgsData: [],
      checkedDetail: [],
      checkedDetail7: [],
      checkedDetail8: [],
      checkedDetail9: [],
      checkedDetail11: [],
      checkedDetail12: [],
      checkedDetail13: [],
      checkedDetail14: [],
      relationshipOptions: [
        {
          value: 1,
          label: '本人或户主'
        }, {
          value: 2,
          label: '配偶'
        }, {
          value: 3,
          label: '子'
        }, {
          value: 4,
          label: '女'
        }, {
          value: 5,
          label: '孙子，孙女，外孙子，外孙女...'
        }, {
          value: 6,
          label: '父母'
        }, {
          value: 7,
          label: '祖父母或外祖父母'
        }, {
          value: 8,
          label: '兄，弟，姐，妹'
        }, {
          value: 0,
          label: '其他'
        }
      ],
      idTypeOptions: [
        {
          value: 1,
          label: '居民身份证'
        }, {
          value: 2,
          label: '外国护照'
        }, {
          value: 3,
          label: '港澳居民来往内地通行证'
        }, {
          value: 4,
          label: '台湾居民来往大陆通行证'
        }, {
          value: 5,
          label: '外国人永久居留身份证(外国人永久居留证)'
        }, {
          value: 6,
          label: '中华人民共和国港澳居民居住证'
        }, {
          value: 7,
          label: '中华人民共和国台湾居民居住证'
        }, {
          value: 8,
          label: '中华人民共和国外国人工作许可证(A类)'
        }, {
          value: 9,
          label: '中华人民共和国外国人工作许可证(B类)'
        }, {
          value: 10,
          label: '中华人民共和国外国人工作许可证(C类)'
        }
      ],
      tabPosition: 'left',
      staffMsgsData: [],
      companyRow: {},
      staffCount: {},
      addStaffDrawer: false,
      updateStaffDrawer: false,
      searchLoading: false,
      showNewTabPane: 'first',
      insetId: null,
      oldFrom: {},
      addStaffsFrom: {
        company_id: null,
        is_inservice: 1,
        staff_name: null,
        work_nnumber: null,
        qt_number_type: null,
        qt_staff_id_number: null,
        staff_phone: null,
        number_type: 1,
        staff_id_number: null,
        native_place: null,
        marital_status: null,
        political_status: null,
        staff_reg_at: null,
        staff_leave_at: null,
        gender: null,
        nationality: null,
        birthday: null,
        identity_validation: 1,
        type_employment: 1,
        employment_situation: null,
        deduction_expenses: 1
      },
      addStaffRules: {
        staff_name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        type_employment: [
          { required: true, message: '请选择任职受雇从业类型', trigger: 'blur' }
        ],
        staff_phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        staff_reg_at: [
          { required: true, message: '请选择入职时间', trigger: 'blur' }
        ],
        number_type: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        staff_id_number: [
          { required: true, message: '请填写证件号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证格式错误',
            trigger: 'blur'
          }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: '请填写出生日期', trigger: 'blur' }
        ],
        nationality: [
          { required: true, message: '请填写国籍', trigger: 'blur' }
        ],
        is_inservice: [
          { required: true, message: '人员状态不能为空', trigger: 'blur' }
        ]
      },
      addInOfficeFrom: {
        type_employee: 6,
        employees_group: null,
        jobs: null,
        nature_work: 1,
        length_service: null,
        trial_status: 1,
        probation_period: 2,
        date_conversion: null,
        qq_number: null,
        emergency_person: null,
        emergency_phone: null,
        salary_suspension: null,
        club_discontinuation: null,
        provident_discontinuation: null,
        nature_resignation: null,
        reasons_leaving: null
      },
      addInOfficeFromRules: {
        nature_work: [
          { required: true, message: '请选择工作性质', trigger: 'blur' }
        ]
      },
      addSocialSecurityFrom: {
        insurance_scheme: null,
        insured_city: null,
        registered_the: null,
        is_secuity: 1,
        staff_id_type: null,
        staff_id_number: null,
        month_enrollment: null,
        ting_month_enrollment: null,
        bu_month_enrollment: null,
        security_number: null,
        security_personal_number: null,
        secuity_base: null,
        is_accum: 1,
        accum_starting_month: null,
        accum_ting_starting_month: null,
        accum_bu_starting_month: null,
        accum_account: null,
        accum_base: null
      },
      addFamilyMemberFrom: [],
      addEducationalFrom: [],
      addAttachedDataFrom: [],
      addWorkExperienceFrom: [],
      addFamilyMemberRules: {},
      addTaxRelatedFrom: {
        bank_account: null,
        bank_number: null,
        bank_account_province: null,
        bank_card_status: null,
        personal_investment: null,
        personal_investment_bl: null,
        special: null,
        disability_number: null,
        is_martyrs_family_number: null,
        email: null,
        formal_schooling: null,
        position: null,
        taxpayers_number: null,
        note: null,
        address_permanent: null,
        address_street: null,
        place_residence_full: null,
        address_full: null,
        place_residence: null,
        place_residence_street: null,
        address_contact: null,
        address_contact_street: null,
        address_contact_full: null
      },
      contractFileList: [],
      attachedFileList: [],
      addContractFrom: {
        contract_type: null,
        contract_number: null,
        contract_term: null,
        date_signing: null,
        date_signing_start: null,
        date_signing_end: null,
        contract_status: null,
        contract_note: null,
        contract_file: null
      },
      updateStaffsFrom: {
        company_id: null,
        is_inservice: null,
        staff_name: null,
        work_nnumber: null,
        qt_number_type: null,
        qt_staff_id_number: null,
        staff_phone: null,
        number_type: 1,
        staff_id_number: null,
        native_place: null,
        marital_status: null,
        political_status: null,
        staff_reg_at: null,
        staff_leave_at: null,
        gender: null,
        nationality: null,
        birthday: null,
        identity_validation: null,
        type_employment: null,
        employment_situation: null,
        deduction_expenses: null
      },
      updateInOfficeFrom: {
        type_employee: 6,
        employees_group: null,
        jobs: null,
        nature_work: 1,
        length_service: null,
        trial_status: 1,
        probation_period: 2,
        date_conversion: null,
        qq_number: null,
        emergency_person: null,
        emergency_phone: null,
        salary_suspension: null,
        club_discontinuation: null,
        provident_discontinuation: null,
        nature_resignation: null,
        reasons_leaving: null
      },
      updateSocialSecurityFrom: {
        insurance_scheme: null,
        insured_city: null,
        registered_the: null,
        is_secuity: 1,
        staff_id_type: null,
        staff_id_number: null,
        month_enrollment: null,
        ting_month_enrollment: null,
        bu_month_enrollment: null,
        security_number: null,
        security_personal_number: null,
        secuity_base: null,
        is_accum: 1,
        accum_starting_month: null,
        accum_ting_starting_month: null,
        accum_bu_starting_month: null,
        accum_account: null,
        accum_base: null
      },
      updateTaxRelatedFrom: {
        bank_account: null,
        bank_number: null,
        bank_account_province: null,
        bank_card_status: null,
        personal_investment: null,
        personal_investment_bl: null,
        special: null,
        disability_number: null,
        is_martyrs_family_number: null,
        email: null,
        formal_schooling: null,
        position: null,
        taxpayers_number: null,
        note: null,
        address_permanent: null,
        address_street: null,
        place_residence_full: null,
        address_full: null,
        place_residence: null,
        place_residence_street: null,
        address_contact: null,
        address_contact_street: null,
        address_contact_full: null
      },
      updateContractFrom: {
        contract_type: null,
        contract_number: null,
        contract_term: null,
        date_signing: null,
        date_signing_start: null,
        date_signing_end: null,
        contract_status: null,
        contract_note: null,
        contract_file: null
      },
      updateFamilyMemberFrom: [],
      updateEducationalFrom: [],
      updateWorkExperienceFrom: [],
      updateAttachedDataFrom: []
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    '$route': 'gettingData',
    colOptions (val) {
      if (val) {
        var arr = this.colSelect.filter(i => val.indexOf(i) < 0)
        // console.log(arr)
        this.colData.filter(i => {
          if (arr.indexOf(i.title) > -1) {
            i.istrue = false
          } else {
            i.istrue = true
          }
        })
      }
    }
  },
  created () {
    this.gettingData()
  },
  mounted () {
    this.getRoles()
  },
  methods: {
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItem(query)
        }, 200)
      } else {
        this.searchStaffMsgsData = []
      }
    },
    handleSearchCompanyChange (val) {
      this.page = 1
      this.getRoles()
    },
    searchArrItem (name) {
      this.$axios.post('/api/staff/searchArrItem?page=' + this.page, {
        params: {
          pageSize: this.pageSize,
          cid: this.companyRow.cid,
          name: name
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchStaffMsgsData = data.data.staffMsgsData.data
            console.log('====this.searchStaffMsgsData====', this.searchStaffMsgsData)
          }
        })
    },
    heaherChange (e, key) {
      console.log(e)
      console.log(key)
    },
    gettingData () {
      this.insetId = null
      this.companyRow.cid = this.$route.query.company_id
    },
    getRoles () {
      this.$axios.post('/api/staff/msgslist?page=' + this.page, {
        params: {
          pageSize: this.pageSize,
          cid: this.companyRow.cid,
          searchArr: this.searchArr
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyRow = data.data.companyRow
            this.staffCount = data.data.staffCount
            this.staffMsgsData = data.data.staffMsgsData.data
            this.total = data.data.staffMsgsData.total
            // console.log('===optionalColumn====', data.data.optionalColumn)
          }
        })
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getRoles(1)
    },
    handleCurrentChange (val) {
      this.page = val
      this.getRoles()
    },
    handleAddStaffOpen () {
      this.addStaffDrawer = true
    },
    submitAddStaff () {
      this.addStaffsFrom.company_id = this.companyRow.cid
      if (this.addStaffsFrom.company_id === null) {
        this.$message.error('公司ID为NULL')
      }
      this.$refs['addStaffsFrom'].validate(valid => {
        if (valid) {
          this.$axios.post('/api/staff/store', this.addStaffsFrom).then(res => {
            let { data } = res
            if (data.code === 0) {
              this.insetId = data.data.insetId
              this.addStaffsFrom = {}
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    submitAddForm (form) {
      if (this.insetId === null) {
        this.$message.error('请先保存基本信息')
        return
      }
      if (this.companyRow.cid === null) {
        this.$message.error('公司ID不能为空')
        return
      }
      if (form === 'addFamilyMemberFrom' || form === 'addEducationalFrom' || form === 'addWorkExperienceFrom' || form === 'addAttachedDataFrom') {
        this.$axios
          .post('api/staff/addfrom', {
            params: {
              company_id: this.companyRow.cid,
              insetId: this.insetId,
              addFrom: this[form],
              value: form,
              file: this.attachedFileList
            }
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.insetId = data.data.insetId
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      } else {
        this.$refs[form].validate(valid => {
          if (valid) {
            this.$axios
              .post('api/staff/addfrom', {
                params: {
                  company_id: this.companyRow.cid,
                  insetId: this.insetId,
                  addFrom: this[form],
                  value: form,
                  file: this.contractFileList
                }
              })
              .then(({ data }) => {
                if (data.code === 0) {
                  this.insetId = data.data.insetId
                  this.$message.success(data.msg)
                } else {
                  this.$message.error(data.msg)
                }
              })
              .catch()
          }
        })
      }
      // console.log('===this.addFamilyMemberFrom===', this.addFamilyMemberFrom)
    },
    handleAddStaffBeforeClose (done) {
      this.addStaffsFrom = {}
      this.insetId = null
      done()
      this.getRoles()
    },
    rowClassName ({ row, rowIndex }) {
      row.xh = rowIndex + 1
    },
    handleDetailSelectionChange (selection) {
      if (selection.length > 1) {
        this.$refs.tb.clearSelection()
        this.$refs.tb.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail = selection
      }
    },
    handleDeleteDetails () {
      if (this.checkedDetail.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail.length; i++) {
          this.addFamilyMemberFrom.splice(this.checkedDetail[i].xh - 1, 1)
        }
      }
    },
    handleDeleteAllDetails () {
      this.addFamilyMemberFrom = []
    },
    addFamilyMemberFun () {
      let obj = {}
      obj.relationship = null
      obj.family_name = null
      obj.family_id_type = 1
      obj.family_id_number = null
      obj.family_birth = null
      obj.family_nationality = null
      obj.family_work_unit = null
      obj.family_remarks = null
      this.addFamilyMemberFrom.push(obj)
    },
    addEducationalFun () {
      let obj = {}
      obj.admission_time = null
      obj.graduation_time = null
      obj.school = null
      obj.major = null
      this.addEducationalFrom.push(obj)
    },
    rowClassName7 ({ row, rowIndex }) {
      row.xh7 = rowIndex + 1
    },
    handleDetailSelectionChange7 (selection) {
      if (selection.length > 1) {
        this.$refs.tb7.clearSelection()
        this.$refs.tb7.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail7 = selection
      }
    },
    handleDeleteDetails7 () {
      if (this.checkedDetail7.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail7.length; i++) {
          this.addEducationalFrom.splice(this.checkedDetail7[i].xh7 - 1, 1)
        }
        // this.addEducationalFrom.splice(this.checkedDetail7[0].xh7 - 1, 1)
      }
    },
    handleDeleteAllDetails7 () {
      this.addEducationalFrom = []
    },
    addEducationalFun8 () {
      let obj = {}
      obj.staff_reg_at = null
      obj.date_departure = null
      obj.company_name = null
      obj.hold_post = null
      this.addWorkExperienceFrom.push(obj)
    },
    rowClassName8 ({ row, rowIndex }) {
      row.xh8 = rowIndex + 1
    },
    handleDetailSelectionChange8 (selection) {
      if (selection.length > 1) {
        this.$refs.tb7.clearSelection()
        this.$refs.tb7.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail8 = selection
      }
    },
    handleDeleteDetails8 () {
      if (this.checkedDetail8.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail8.length; i++) {
          this.addWorkExperienceFrom.splice(this.checkedDetail8[i].xh8 - 1, 1)
        }
        // this.addWorkExperienceFrom.splice(this.checkedDetail8[0].xh8 - 1, 1)
      }
    },
    handleDeleteAllDetails8 () {
      this.addWorkExperienceFrom = []
    },
    addEducationalFun9 () {
      let obj = {}
      obj.attached_name = null
      this.addAttachedDataFrom.push(obj)
    },
    rowClassName9 ({ row, rowIndex }) {
      row.xh9 = rowIndex + 1
    },
    handleDetailSelectionChange9 (selection) {
      if (selection.length > 1) {
        this.$refs.tb7.clearSelection()
        this.$refs.tb7.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail9 = selection
      }
    },
    handleDeleteDetails9 () {
      if (this.checkedDetail9.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail9.length; i++) {
          this.addAttachedDataFrom.splice(this.checkedDetail9[i].xh9 - 1, 1)
        }
        // this.addAttachedDataFrom.splice(this.checkedDetail8[0].xh9 - 1, 1)
      }
    },
    handleDeleteAllDetails9 () {
      this.addAttachedDataFrom = []
    },
    handleWorkSuccessAttached (xh9, res, file) {
      var arr = []
      if (res.code === 0) {
        arr.push({ url: res.data.signedUrl, buphoto: res.data.buphoto, name: file.name, uid: file.uid })
        this.attachedFileList[xh9 - 1] = arr
        if (this.addAttachedDataFrom[xh9 - 1].attached_name === null) {
          this.addAttachedDataFrom[xh9 - 1].attached_name = file.name
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    handleWorkRemove2 (xh9, file, fileList) {
      this.attachedFileList[xh9 - 1] = fileList
      if (this.addAttachedDataFrom[xh9 - 1].attached_name === file.name) {
        this.addAttachedDataFrom[xh9 - 1].attached_name = null
      }
    },
    handleWorkPreview2 (file) {
      var tempwindow = window.open('_blank')
      tempwindow.location = file.url
    },
    handleWorkSuccess (res, file) {
      if (res.code === 0) {
        this.contractFileList.push({ url: res.data.signedUrl, name: file.name, uid: file.uid })
      } else {
        this.$message.error(res.msg)
      }
    },
    handleAvatarChange (res, file) {
      this.contractFileList = file
    },
    handleWorkRemove (file, fileList) {
      this.contractFileList = fileList
    },
    handleWorkPreview (file) {
      var tempwindow = window.open('_blank')
      tempwindow.location = file.url
    },
    deleteRow (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios
            .delete('api/staff/del/' + id, {})
            .then(({ data }) => {
              if (data.code === 1) {
                this.getRoles()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleStaffUpdateOpen (id, index) {
      this.contractFileList = []
      this.$axios.get('/api/staff/moren?id=' + id + '&cid=' + this.companyRow.cid).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.updateStaffDrawer = true
          this.oldFrom = data.data.staffMsgs
          this.insetId = data.data.staffMsgs.id
          this.updateStaffsFrom.company_id = data.data.staffMsgs.company_id
          this.updateStaffsFrom.is_inservice = data.data.staffMsgs.is_inservice
          this.updateStaffsFrom.staff_name = data.data.staffMsgs.staff_name
          this.updateStaffsFrom.work_nnumber = data.data.staffMsgs.work_nnumber
          this.updateStaffsFrom.qt_number_type = data.data.staffMsgs.qt_number_type
          this.updateStaffsFrom.qt_staff_id_number = data.data.staffMsgs.qt_staff_id_number
          this.updateStaffsFrom.staff_phone = data.data.staffMsgs.staff_phone
          this.updateStaffsFrom.number_type = data.data.staffMsgs.number_type
          this.updateStaffsFrom.staff_id_number = data.data.staffMsgs.staff_id_number
          this.updateStaffsFrom.native_place = data.data.staffMsgs.native_place
          this.updateStaffsFrom.marital_status = data.data.staffMsgs.marital_status
          this.updateStaffsFrom.political_status = data.data.staffMsgs.political_status
          this.updateStaffsFrom.staff_reg_at = data.data.staffMsgs.staff_reg_at
          this.updateStaffsFrom.staff_leave_at = data.data.staffMsgs.staff_leave_at
          this.updateStaffsFrom.gender = data.data.staffMsgs.gender
          this.updateStaffsFrom.nationality = data.data.staffMsgs.nationality
          this.updateStaffsFrom.birthday = data.data.staffMsgs.birthday
          this.updateStaffsFrom.identity_validation = data.data.staffMsgs.identity_validation
          this.updateStaffsFrom.type_employment = data.data.staffMsgs.type_employment
          this.updateStaffsFrom.employment_situation = data.data.staffMsgs.employment_situation
          this.updateStaffsFrom.deduction_expenses = data.data.staffMsgs.deduction_expenses
          this.updateInOfficeFrom.type_employee = data.data.staffMsgs.type_employee
          this.updateInOfficeFrom.employees_group = data.data.staffMsgs.employees_group
          this.updateInOfficeFrom.jobs = data.data.staffMsgs.jobs
          this.updateInOfficeFrom.nature_work = data.data.staffMsgs.nature_work
          this.updateInOfficeFrom.length_service = data.data.staffMsgs.length_service
          this.updateInOfficeFrom.trial_status = data.data.staffMsgs.trial_status
          this.updateInOfficeFrom.probation_period = data.data.staffMsgs.probation_period
          this.updateInOfficeFrom.date_conversion = data.data.staffMsgs.date_conversion
          this.updateInOfficeFrom.qq_number = data.data.staffMsgs.qq_number
          this.updateInOfficeFrom.emergency_person = data.data.staffMsgs.emergency_person
          this.updateInOfficeFrom.emergency_phone = data.data.staffMsgs.emergency_phone
          this.updateInOfficeFrom.salary_suspension = data.data.staffMsgs.salary_suspension
          this.updateInOfficeFrom.club_discontinuation = data.data.staffMsgs.club_discontinuation
          this.updateInOfficeFrom.provident_discontinuation = data.data.staffMsgs.provident_discontinuation
          this.updateInOfficeFrom.nature_resignation = data.data.staffMsgs.nature_resignation
          this.updateInOfficeFrom.reasons_leaving = data.data.staffMsgs.reasons_leaving

          this.updateSocialSecurityFrom.insurance_scheme = data.data.staffMsgs.insurance_scheme
          this.updateSocialSecurityFrom.insured_city = data.data.staffMsgs.insured_city
          this.updateSocialSecurityFrom.registered_the = data.data.staffMsgs.registered_the
          this.updateSocialSecurityFrom.is_secuity = data.data.staffMsgs.is_secuity
          this.updateSocialSecurityFrom.is_accum = data.data.staffMsgs.is_accum
          if (data.data.staffMsgs.secuity !== null) {
            this.updateSocialSecurityFrom.staff_id_type = data.data.staffMsgs.secuity.staff_id_type
            this.updateSocialSecurityFrom.staff_id_number = data.data.staffMsgs.secuity.staff_id_number
            this.updateSocialSecurityFrom.month_enrollment = data.data.staffMsgs.secuity.month_enrollment
            this.updateSocialSecurityFrom.ting_month_enrollment = data.data.staffMsgs.secuity.ting_month_enrollment
            this.updateSocialSecurityFrom.bu_month_enrollment = data.data.staffMsgs.secuity.bu_month_enrollment
            this.updateSocialSecurityFrom.security_number = data.data.staffMsgs.secuity.security_number
            this.updateSocialSecurityFrom.security_personal_number = data.data.staffMsgs.secuity.security_personal_number
            this.updateSocialSecurityFrom.secuity_base = data.data.staffMsgs.secuity.secuity_base
          }
          if (data.data.staffMsgs.accum !== null) {
            this.updateSocialSecurityFrom.accum_starting_month = data.data.staffMsgs.accum.accum_starting_month
            this.updateSocialSecurityFrom.accum_ting_starting_month = data.data.staffMsgs.accum.accum_ting_starting_month
            this.updateSocialSecurityFrom.accum_bu_starting_month = data.data.staffMsgs.accum.accum_bu_starting_month
            this.updateSocialSecurityFrom.accum_account = data.data.staffMsgs.accum.accum_account
            this.updateSocialSecurityFrom.accum_base = data.data.staffMsgs.accum.accum_base
          }
          this.updateTaxRelatedFrom.bank_account = data.data.staffMsgs.reasons_leaving
          this.updateTaxRelatedFrom.bank_number = data.data.staffMsgs.bank_number
          this.updateTaxRelatedFrom.bank_account_province = data.data.staffMsgs.bank_account_province
          this.updateTaxRelatedFrom.bank_card_status = data.data.staffMsgs.bank_card_status
          this.updateTaxRelatedFrom.personal_investment = data.data.staffMsgs.personal_investment
          this.updateTaxRelatedFrom.personal_investment_bl = data.data.staffMsgs.personal_investment_bl
          this.updateTaxRelatedFrom.special = data.data.staffMsgs.special
          this.updateTaxRelatedFrom.disability_number = data.data.staffMsgs.disability_number
          this.updateTaxRelatedFrom.is_martyrs_family_number = data.data.staffMsgs.is_martyrs_family_number
          this.updateTaxRelatedFrom.email = data.data.staffMsgs.email
          this.updateTaxRelatedFrom.formal_schooling = data.data.staffMsgs.formal_schooling
          this.updateTaxRelatedFrom.position = data.data.staffMsgs.position
          this.updateTaxRelatedFrom.taxpayers_number = data.data.staffMsgs.taxpayers_number
          this.updateTaxRelatedFrom.note = data.data.staffMsgs.note
          this.updateTaxRelatedFrom.address_permanent = data.data.staffMsgs.address_permanent
          this.updateTaxRelatedFrom.address_street = data.data.staffMsgs.address_street
          this.updateTaxRelatedFrom.place_residence_full = data.data.staffMsgs.place_residence_full
          this.updateTaxRelatedFrom.address_full = data.data.staffMsgs.address_full
          this.updateTaxRelatedFrom.place_residence = data.data.staffMsgs.place_residence
          this.updateTaxRelatedFrom.place_residence_street = data.data.staffMsgs.place_residence_street
          this.updateTaxRelatedFrom.address_contact = data.data.staffMsgs.address_contact
          this.updateTaxRelatedFrom.address_contact_street = data.data.staffMsgs.address_contact_street
          this.updateTaxRelatedFrom.address_contact_full = data.data.staffMsgs.address_contact_full

          this.updateContractFrom.contract_type = data.data.staffMsgs.contract_type
          this.updateContractFrom.contract_number = data.data.staffMsgs.contract_number
          this.updateContractFrom.contract_term = data.data.staffMsgs.contract_term
          this.updateContractFrom.date_signing = data.data.staffMsgs.date_signing
          this.updateContractFrom.date_signing_start = data.data.staffMsgs.date_signing_start
          this.updateContractFrom.date_signing_end = data.data.staffMsgs.date_signing_end
          this.updateContractFrom.contract_status = data.data.staffMsgs.contract_status
          this.updateContractFrom.contract_note = data.data.staffMsgs.contract_note
          this.updateContractFrom.contract_file = data.data.staffMsgs.contract_file
          if (this.updateContractFrom.contract_file) {
            this.contractFileList.push({
              url: data.data.staffMsgs.contract_file_oss,
              name: data.data.staffMsgs.contract_file_name,
              contract_file: data.data.staffMsgs.contract_file
            })
          }
          this.updateFamilyMemberFrom = data.data.staffMsgs.family
          this.updateEducationalFrom = data.data.staffMsgs.educational
          this.updateWorkExperienceFrom = data.data.staffMsgs.work_experience
          this.updateAttachedDataFrom = data.data.staffMsgs.attachedName
          this.attachedFileList = data.data.staffMsgs.attached
        }
      })
    },
    handleUpStaffBeforeClose (done) {
      this.insetId = null
      this.getRoles()
      done()
    },
    updateChange (col, val, fieldName, ccId = null) {
      let oldValue = null
      if (val === 'staff_id_type' ||
          val === 'staff_id_number' ||
          val === 'month_enrollment' ||
          val === 'ting_month_enrollment' ||
          val === 'bu_month_enrollment' ||
          val === 'security_number' ||
          val === 'security_personal_number' ||
          val === 'secuity_base'
      ) {
        oldValue = this.oldFrom['secuity'][val]
      } else if (
        val === 'accum_starting_month' ||
        val === 'accum_ting_starting_month' ||
        val === 'accum_bu_starting_month' ||
        val === 'accum_base' ||
        val === 'accum_account'
      ) {
        oldValue = this.oldFrom['accum'][val]
      } else {
        oldValue = this.oldFrom[val]
      }
      let newValue = this[col][val]
      let companyId = this.companyRow.cid
      let insetId = this.insetId

      this.$axios
        .post('api/staff/updateNewStaff', {
          col: col,
          val: val,
          oldValue: oldValue,
          newValue: newValue,
          fieldName: fieldName,
          company_id: companyId,
          insertId: insetId,
          ccId: ccId
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          }
        })
    },
    handleWorkSuccessUpdate (res, file) {
      if (res.code === 0) {
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    addFamilyMemberFun11 () {
      let obj = {}
      obj.id = null
      obj.company_id = this.companyRow.cid
      obj.staff_id = this.insetId
      obj.relationship = null
      obj.family_name = null
      obj.family_id_type = 1
      obj.family_id_number = null
      obj.family_birth = null
      obj.family_nationality = null
      obj.family_work_unit = null
      obj.family_remarks = null
      this.updateFamilyMemberFrom.push(obj)
    },
    rowClassName11 ({ row, rowIndex }) {
      row.xh11 = rowIndex + 1
    },
    handleDetailSelectionChange11 (selection) {
      if (selection.length > 1) {
        this.$refs.tb11.clearSelection()
        this.$refs.tb11.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail11 = selection
      }
    },
    handleDeleteDetails11 () {
      if (this.checkedDetail11.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail11.length; i++) {
          this.updateFamilyMemberFrom.splice(this.checkedDetail11[i].xh11 - 1, 1)
          this.$axios
            .post('api/staff/fmlDel', {
              company_id: this.companyRow.cid,
              insertId: this.insetId,
              col: 'updateFamilyMemberFrom',
              id: this.checkedDetail11[i].id
            })
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
              }
            })
        }
      }
    },
    addEducationalFun12 () {
      let obj = {}
      obj.id = null
      obj.staff_id = this.insetId
      obj.company_id = this.companyRow.cid
      obj.graduation_time = null
      obj.school = null
      obj.major = null
      this.updateEducationalFrom.push(obj)
    },
    rowClassName12 ({ row, rowIndex }) {
      row.xh12 = rowIndex + 1
    },
    handleDetailSelectionChange12 (selection) {
      if (selection.length > 1) {
        this.$refs.tb12.clearSelection()
        this.$refs.tb12.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail12 = selection
      }
    },
    handleDeleteDetails12 () {
      if (this.checkedDetail12.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail12.length; i++) {
          this.updateEducationalFrom.splice(this.checkedDetail12[i].xh12 - 1, 1)
          this.$axios
            .post('api/staff/fmlDel', {
              company_id: this.companyRow.cid,
              insertId: this.insetId,
              col: 'updateEducationalFrom',
              id: this.checkedDetail12[i].id
            })
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
              }
            })
        }
      }
    },
    addEducationalFun13 () {
      let obj = {}
      obj.id = null
      obj.company_id = this.companyRow.cid
      obj.staff_id = this.insetId
      obj.staff_reg_at = null
      obj.date_departure = null
      obj.company_name = null
      obj.hold_post = null
      this.updateWorkExperienceFrom.push(obj)
    },
    rowClassName13 ({ row, rowIndex }) {
      row.xh13 = rowIndex + 1
    },
    handleDetailSelectionChange13 (selection) {
      if (selection.length > 1) {
        this.$refs.tb13.clearSelection()
        this.$refs.tb13.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail13 = selection
      }
    },
    handleDeleteDetails13 () {
      if (this.checkedDetail13.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail13.length; i++) {
          this.updateWorkExperienceFrom.splice(this.checkedDetail13[i].xh13 - 1, 1)
          this.$axios
            .post('api/staff/fmlDel', {
              company_id: this.companyRow.cid,
              insertId: this.insetId,
              col: 'updateWorkExperienceFrom',
              id: this.checkedDetail13[i].id
            })
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
              }
            })
        }
      }
    },
    addEducationalFun14 () {
      let obj = {}
      obj.id = null
      obj.company_id = this.companyRow.cid
      obj.staff_id = this.insetId
      obj.attached_name = null
      this.updateAttachedDataFrom.push(obj)
    },
    rowClassName14 ({ row, rowIndex }) {
      row.xh14 = rowIndex + 1
    },
    handleDetailSelectionChange14 (selection) {
      if (selection.length > 1) {
        this.$refs.tb14.clearSelection()
        this.$refs.tb14.toggleRowSelection(selection.pop())
      } else {
        this.checkedDetail14 = selection
      }
    },
    handleDeleteDetails14 () {
      if (this.checkedDetail14.length === 0) {
        this.$alert('请先选择要删除的数据', '提示', {confirmButtonText: '确定'})
      } else {
        for (var i = 0; i < this.checkedDetail14.length; i++) {
          this.updateAttachedDataFrom.splice(this.checkedDetail14[i].xh14 - 1, 1)
          this.$axios
            .post('api/staff/fmlDel', {
              company_id: this.companyRow.cid,
              insertId: this.insetId,
              col: 'updateAttachedDataFrom',
              id: this.checkedDetail14[i].id
            })
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
              }
            })
        }
      }
    },
    handleWorkSuccessAttached14 (xh14, res, file) {
      var arr = []
      if (res.code === 0) {
        arr.push({ url: res.data.signedUrl, buphoto: res.data.buphoto, name: file.name, uid: file.uid })
        this.attachedFileList[xh14 - 1] = arr
        if (this.updateAttachedDataFrom[xh14 - 1].attached_name === null) {
          this.updateAttachedDataFrom[xh14 - 1].attached_name = file.name
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    handleWorkRemove14 (xh14, file, fileList) {
      this.attachedFileList[xh14 - 1] = fileList
      if (this.updateAttachedDataFrom[xh14 - 1].attached_name === file.name) {
        this.updateAttachedDataFrom[xh14 - 1].attached_name = null
      }
    },
    updateStaffFun (form) {
      if (this.insetId === null) {
        this.$message.error('请先保存基本信息')
        return
      }
      if (this.companyRow.cid === null) {
        this.$message.error('公司ID不能为空')
        return
      }
      this.$axios
        .post('api/staff/updatefrom', {
          params: {
            company_id: this.companyRow.cid,
            insetId: this.insetId,
            addFrom: this[form],
            value: form,
            file: this.attachedFileList
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.insetId = data.data.insetId
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    handlerelatedStaff () {
      alert('暂无数据')
      // this.$axios.get('/api/admin/finance/dutiableyijian?company_id=' + this.upData.company_id + '&company_name=' + this.upData.company_name)
      //   .then((res) => {
      //     const { data } = res
      //     if (data.code === 0) {
      //       this.dutiable = data.data.dutiable
      //       this.$message.success(data.msg)
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .popper {
    width: 180px
    height: 10rem
    overflow-y: scroll
  }
  .el-drawer__wrapper >>> .el-drawer {
    overflow-y: auto;
  }
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #4c87fc;
    font-size: 0.36rem;
    font-weight: 400;
  }
  .authority >>> .el-tabs__header
    padding-left: .01rem
  .authority >>> .el-select
   width :100%
  .authority >>> .el-input
   width :100%
  .authority >>> .el-tabs__nav-wrap::after
                   display:none !important
  .el-checkbox.is-bordered
    margin-bottom: .2rem
  .authority
    marginLeft()
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .mtb30
      margin-bottom: .6rem
    .mt10
      margin-top: .2rem
    .pb15
      padding-bottom: .3rem
    .role-list
      min-height: calc(100vh - 210px)
      padding-right: 12px
      border-right: 1px solid #ebebeb
      .list
        margin-top: .3rem
    .more-icon
      float: right
      color: #5789F4
      cursor: pointer
    .sel-role
      cursor: pointer
    .active-role
      color: #5789f4
    .node-header
      line-height: .88rem
      padding-left: .4rem
      margin-bottom: .3rem
      color: #5789F4
    .node-empty
      text-align: center
      color: rgba(0, 0, 0, .3)
    .node-con
      padding-left: .4rem
    .check-title
      margin-right: .4rem
    .tr
      text-align: right
    .el-checkbox.is-bordered+.el-checkbox.is-bordered
      margin-left: 0
    .el-col-20{
      width :100%
    }
  .my_style >>> .el-form-item__label {
                  width: 150px!important;
                }
  .my_style >>> .el-form-item__content {
                  margin-left: 150px!important;
                }
  .my_style >>> .el-form-item--mini {
                  width: 50%!important;
                  float left!important;
                }
  .my_style >>> .dplx-item-title {
                  border-left: 6px solid #4c87fc;
                  box-sizing: border-box;
                  margin: 4px 0;
                  padding-left: 10px;
                  position: relative;
                  margin-bottom 15px;
                }
  .my_style >>> .el-tabs__nav{
                  height 770px
                }

.el-drawer__wrapper >>> .el-timeline-item__wrapper {
                                         top: 0;
                                       }

.el-collapse >>> .el-collapse-item__header {
                   color: #4C87FC;
                   font-weight: bold;
                 }

.el-collapse >>> .el-collapse-item__arrow {
                   color: #4C87FC;
                 }

</style>



// WEBPACK FOOTER //
// src/pages/staff_info/StaffMsgs.vue